import React, { useCallback, useEffect, useState } from 'react';
import { Search, CreditCard, Calendar, User, BookOpen, DollarSign, Download, AlertTriangle, X, Grid, List, FileSpreadsheet, Edit, Trash2, FileText } from 'lucide-react';
import { jsPDF } from "jspdf";
import * as XLSX from 'xlsx';
import Sidebar from '../components/Sidebarpaiment';
import axios from 'axios';
import { nombreEnLettres } from '../utils/numberToWords';
import { SUP2I_LOGO_BASE64 } from '../assets/sup2iLogo';

const API_BASE_URL = '    https://vmi1977988.contaboserver.net/api2';

const ListePaiements = () => {
  const userStr = localStorage.getItem('user');
  const loggedInUser = userStr ? JSON.parse(userStr) : null;
  const userEmail = loggedInUser?.email?.toLowerCase();
  const canEditObs = ['hiba@supemir.com', 'm.sahmy@supemir.com', 'khadija@test.com'].includes(userEmail);
  const isHiba = userEmail === 'hiba@supemir.com';

  const [paiements, setPaiements] = useState([]);
  const [expirés, setExpirés] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterNiveauFormation, setFilterNiveauFormation] = useState(''); // ✅ AJOUTÉ
  const [filtreAnnee, setFiltreAnnee] = useState('');
  const [filterStatut, setFilterStatut] = useState('actifs'); // 'actifs', 'inactifs', or 'tous'
  const [niveauxFormation, setNiveauxFormation] = useState([]);           // ✅ AJOUTÉ
  const [viewMode, setViewMode] = useState('table');
  const [filteredPaiements, setFilteredPaiements] = useState([]);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [selectedPaiement, setSelectedPaiement] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showObsModal, setShowObsModal] = useState(false);
  const [selectedEtudiantForObs, setSelectedEtudiantForObs] = useState(null);
  const [obsValue, setObsValue] = useState('');
  const [obsSubmitting, setObsSubmitting] = useState(false);
  const [paymentObsValue, setPaymentObsValue] = useState('');
  const [editForm, setEditForm] = useState({
    montant: '',
    note: '',
    numeroSerie: '',
    nombreMois: '',
    moisDebut: '',
    modePayment: null,
    banque: '',
    numeroCheque: '',
    datePaiement: ''
  });

  // ✅ AJOUTÉ : Filtres avancés par période
  const [showAdvancedFilters, setShowAdvancedFilters] = useState(false);
  const [filters, setFilters] = useState({
    typePeriode: 'tous', // 'tous', 'jour', 'semaine', 'mois', 'personnalise'
    dateCible: '',
    moisCible: '',
    dateDebut: '',
    dateFin: '',
    montantMin: '',
    montantMax: '',
    modePayment: ''
  });

  const getAuthConfig = () => {
    const token = localStorage.getItem('token');
    return { headers: { Authorization: `Bearer ${token}` } };
  };

  const fetchPaiements = useCallback(async () => {
    try {
      const config = getAuthConfig();

      // 1. Charger tous les paiements
      const resP = await fetch(`${API_BASE_URL}/paiements`, config);
      const dataP = await resP.json();

      // 2. Charger tous les étudiants pour identifier ceux qui ont 0 paiement
      const resE = await fetch(`${API_BASE_URL}/etudiant`, config);
      const dataE = await resE.json();

      // IDs des étudiants qui ont au moins un paiement
      const paidStudentIds = new Set(dataP.map(p => p.etudiant?._id?.toString()).filter(Boolean));

      // Créer des paiements fictifs (dummy) pour les étudiants n'ayant aucun paiement (actifs et inactifs)
      const dummyPaiements = dataE
        .filter(e => !paidStudentIds.has(e._id?.toString()))
        .map(e => ({
          _id: `dummy_${e._id}`,
          etudiant: e,
          cours: e.cours || [],
          moisDebut: null,
          nombreMois: 0,
          montant: 0,
          isDummy: true, // Marqueur pour le frontend
          note: 'Aucun paiement enregistré',
          numeroSerie: '—',
          modePayment: 'Non payé',
          createdAt: e.createdAt || new Date()
        }));

      // Fusionner et trier (les paiements réels en premier par date)
      const combinedData = [...dataP, ...dummyPaiements];
      const sortedData = combinedData.sort((a, b) => {
        if (a.isDummy && !b.isDummy) return 1;
        if (!a.isDummy && b.isDummy) return -1;
        return new Date(b.createdAt) - new Date(a.createdAt);
      });

      setPaiements(sortedData);
      setFilteredPaiements(sortedData);
    } catch (err) {
      console.error('Erreur chargement paiements:', err);
      alert('Erreur lors du chargement des paiements');
    }
  }, []);

  useEffect(() => {
    fetchPaiements();
  }, [fetchPaiements]);

  // ✅ AJOUTÉ : extraire les niveaux uniques pour le filtre
  useEffect(() => {
    const niveaux = [...new Set(
      paiements.map(p => p.etudiant?.niveau).filter(Boolean)
    )].sort();
    setNiveauxFormation(niveaux);
  }, [paiements]);

  // ✅ AJOUTÉ : helper de vérification de date
  const isDateInPeriod = (dateStr, typePeriode, targetDate, targetMonth, dateDebut, dateFin) => {
    if (typePeriode === 'tous') return true;
    if (!dateStr) return false;

    const date = new Date(dateStr);
    date.setHours(0, 0, 0, 0);

    if (typePeriode === 'jour') {
      if (!targetDate) return true;
      const target = new Date(targetDate);
      target.setHours(0, 0, 0, 0);
      return date.getTime() === target.getTime();
    }

    if (typePeriode === 'semaine') {
      if (!targetDate) return true;
      const target = new Date(targetDate);
      target.setHours(0, 0, 0, 0);

      const day = target.getDay();
      const diff = target.getDate() - day + (day === 0 ? -6 : 1);
      const monday = new Date(target.setDate(diff));
      monday.setHours(0, 0, 0, 0);

      const sunday = new Date(monday);
      sunday.setDate(monday.getDate() + 6);
      sunday.setHours(23, 59, 59, 999);

      return date >= monday && date <= sunday;
    }

    if (typePeriode === 'mois') {
      if (!targetMonth) return true;
      const [year, month] = targetMonth.split('-').map(Number);
      return date.getFullYear() === year && (date.getMonth() + 1) === month;
    }

    if (typePeriode === 'personnalise') {
      if (dateDebut) {
        const start = new Date(dateDebut);
        start.setHours(0, 0, 0, 0);
        if (date < start) return false;
      }
      if (dateFin) {
        const end = new Date(dateFin);
        end.setHours(23, 59, 59, 999);
        if (date > end) return false;
      }
      return true;
    }

    return true;
  };

  // ✅ MODIFIÉ : filtrage avec filterNiveauFormation et filtres avancés par période
  useEffect(() => {
    const filtered = paiements.filter(p => {
      const searchLower = searchTerm.toLowerCase();

      const firstName = p.etudiant?.prenom?.toLowerCase() || '';
      const lastName = p.etudiant?.nomDeFamille?.toLowerCase() || '';
      const fullName = p.etudiant?.nomComplet?.toLowerCase() || `${lastName} ${firstName}`.trim();
      const codeEtudiant = p.etudiant?.codeEtudiant?.toLowerCase() || '';

      const matchSearch =
        fullName.includes(searchLower) ||
        firstName.includes(searchLower) ||
        lastName.includes(searchLower) ||
        codeEtudiant.includes(searchLower) ||
        (Array.isArray(p.cours) ? p.cours.join(', ') : p.cours)?.toLowerCase().includes(searchLower) ||
        p.note?.toLowerCase().includes(searchLower) ||
        p.numeroSerie?.toLowerCase().includes(searchLower) ||
        p.numeroSerieManuel?.toLowerCase().includes(searchLower);

      const matchNiveau = !filterNiveauFormation || p.etudiant?.niveau === filterNiveauFormation || p.etudiant?.niveauFormation === filterNiveauFormation;
      const matchAnnee = !filtreAnnee || p.etudiant?.anneeScolaire === filtreAnnee;

      let matchStatut = true;
      if (filterStatut === 'actifs') {
        matchStatut = p.etudiant?.actif === true;
      } else if (filterStatut === 'inactifs') {
        matchStatut = p.etudiant?.actif === false;
      }

      const dateVal = p.datePaiement || p.createdAt;
      const matchPeriode = isDateInPeriod(
        dateVal,
        filters.typePeriode,
        filters.dateCible,
        filters.moisCible,
        filters.dateDebut,
        filters.dateFin
      );

      const matchMontantMin = !filters.montantMin || p.montant >= Number(filters.montantMin);
      const matchMontantMax = !filters.montantMax || p.montant <= Number(filters.montantMax);
      const matchMode = !filters.modePayment || p.modePayment === filters.modePayment;

      return matchSearch && matchNiveau && matchAnnee && matchStatut && matchPeriode && matchMontantMin && matchMontantMax && matchMode;
    });
    setFilteredPaiements(filtered);
  }, [searchTerm, filterNiveauFormation, filtreAnnee, filterStatut, filters, paiements]);

  const handleLogout = () => {
    localStorage.removeItem('token');
    window.location.href = '/';
  };

  const fetchExpirés = async () => {
    try {
      const res = await fetch(`${API_BASE_URL}/paiements/exp`, getAuthConfig());
      const data = await res.json();
      setExpirés(data);
    } catch (err) {
      console.error('Erreur fetch paiements expirés:', err);
    }
  };

  const toggleModal = () => {
    if (!showModal) fetchExpirés();
    setShowModal(!showModal);
  };

  const formatDate = (isoDate) => {
    if (!isoDate) return '—';
    const date = new Date(isoDate);
    return date.toLocaleDateString('fr-FR');
  };

  const calculerDateFin = (debut, nombreMois) => {
    if (!debut) return '';
    const date = new Date(debut);
    date.setMonth(date.getMonth() + Number(nombreMois));
    return date.toLocaleDateString('fr-FR');
  };

  const payerEtudiant = (etudiantId, cours) => {
    localStorage.setItem('paiementPreRempli', JSON.stringify({
      etudiant: etudiantId,
      cours: cours
    }));
    window.location.href = '/ajouter-paiement';
  };

  const openEditModal = (paiement) => {
    setSelectedPaiement(paiement);
    setEditForm({
      montant: paiement.montant,
      note: paiement.note || '',
      numeroSerie: paiement.numeroSerie || '',
      numeroSerieManuel: paiement.numeroSerieManuel || '',
      nombreMois: paiement.nombreMois,
      moisDebut: paiement.moisDebut ? new Date(paiement.moisDebut).toISOString().split('T')[0] : '',
      modePayment: paiement.modePayment || null,
      banque: paiement.banque || '',
      numeroCheque: paiement.numeroCheque || '',
      datePaiement: paiement.datePaiement ? new Date(paiement.datePaiement).toISOString().split('T')[0] : new Date(paiement.createdAt).toISOString().split('T')[0]
    });
    setShowEditModal(true);
  };

  const handleEditSubmit = async () => {
    if (!editForm.numeroSerie || editForm.numeroSerie.trim() === '') {
      alert('❌ Le numéro de série est obligatoire');
      return;
    }

    if (!editForm.montant || parseFloat(editForm.montant) <= 0) {
      alert('❌ Le montant doit être supérieur à 0');
      return;
    }

    if (!editForm.datePaiement) {
      alert('❌ La date de paiement est obligatoire');
      return;
    }

    try {
      const config = getAuthConfig();
      const response = await fetch(`${API_BASE_URL}/paiements/${selectedPaiement._id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          ...config.headers
        },
        body: JSON.stringify(editForm)
      });

      const data = await response.json();

      if (response.ok) {
        alert('✅ Paiement modifié avec succès');
        setShowEditModal(false);
        fetchPaiements();
      } else {
        alert(`❌ ${data.error || 'Erreur lors de la modification'}`);
      }
    } catch (err) {
      console.error('Erreur modification:', err);
      alert('❌ Erreur lors de la modification du paiement');
    }
  };

  const openObsModal = (paiement) => {
    const etudiant = paiement.etudiant;
    if (!etudiant) {
      alert("Erreur : Impossible de trouver l'étudiant pour ce paiement");
      return;
    }
    setSelectedEtudiantForObs({
      id: etudiant._id,
      nomComplet: etudiant.nomComplet || `${etudiant.nomDeFamille || ''} ${etudiant.prenom || ''}`.trim() || 'Étudiant',
      observationFinance: etudiant.observationFinance || '',
      paiementId: paiement._id,
      paymentObservationFinance: paiement.observationFinance || ''
    });
    setObsValue(etudiant.observationFinance || '');
    setPaymentObsValue(paiement.observationFinance || '');
    setShowObsModal(true);
  };

  const handleObsSubmit = async (e) => {
    e.preventDefault();
    if (!selectedEtudiantForObs) return;

    setObsSubmitting(true);
    try {
      const config = getAuthConfig();
      const isDummy = selectedEtudiantForObs.paiementId?.startsWith('dummy_');

      // Mettre à jour l'observation générale de l'étudiant ET l'observation de ce paiement (si ce n'est pas un paiement fictif)
      const promises = [
        axios.put(
          `${API_BASE_URL}/etudiants/${selectedEtudiantForObs.id}/observation-finance`,
          { observationFinance: obsValue },
          config
        )
      ];

      if (!isDummy) {
        promises.push(
          axios.put(
            `${API_BASE_URL}/paiements/${selectedEtudiantForObs.paiementId}`,
            { observationFinance: paymentObsValue },
            config
          )
        );
      }

      await Promise.all(promises);

      // Mettre à jour l'état local (paiements)
      setPaiements(prev => prev.map(p => {
        if (p._id === selectedEtudiantForObs.paiementId) {
          // Si c'est ce paiement spécifique, mettre à jour l'observation de paiement et l'observation générale de l'étudiant
          return {
            ...p,
            observationFinance: paymentObsValue,
            etudiant: p.etudiant ? { ...p.etudiant, observationFinance: obsValue } : null
          };
        } else if (p.etudiant && p.etudiant._id === selectedEtudiantForObs.id) {
          // Si c'est un autre paiement du même étudiant, mettre à jour l'observation générale
          return {
            ...p,
            etudiant: {
              ...p.etudiant,
              observationFinance: obsValue
            }
          };
        }
        return p;
      }));

      // Mettre à jour filteredPaiements
      setFilteredPaiements(prev => prev.map(p => {
        if (p._id === selectedEtudiantForObs.paiementId) {
          return {
            ...p,
            observationFinance: paymentObsValue,
            etudiant: p.etudiant ? { ...p.etudiant, observationFinance: obsValue } : null
          };
        } else if (p.etudiant && p.etudiant._id === selectedEtudiantForObs.id) {
          return {
            ...p,
            etudiant: {
              ...p.etudiant,
              observationFinance: obsValue
            }
          };
        }
        return p;
      }));

      // Mettre à jour selectedPaiement si c'est le même étudiant ou paiement
      if (selectedPaiement) {
        if (selectedPaiement._id === selectedEtudiantForObs.paiementId) {
          setSelectedPaiement(prev => ({
            ...prev,
            observationFinance: paymentObsValue,
            etudiant: prev.etudiant ? { ...prev.etudiant, observationFinance: obsValue } : null
          }));
        } else if (selectedPaiement.etudiant && selectedPaiement.etudiant._id === selectedEtudiantForObs.id) {
          setSelectedPaiement(prev => ({
            ...prev,
            etudiant: {
              ...prev.etudiant,
              observationFinance: obsValue
            }
          }));
        }
      }

      setShowObsModal(false);
      setSelectedEtudiantForObs(null);
      alert('✅ Observations financières mises à jour avec succès');
    } catch (err) {
      console.error('Erreur mise à jour observations:', err);
      alert(err.response?.data?.error || "Erreur lors de la mise à jour des observations");
    } finally {
      setObsSubmitting(false);
    }
  };

  const handleDelete = async (paiement) => {
    const confirmation = window.confirm(
      `⚠️ Êtes-vous sûr de vouloir supprimer ce paiement ?\n\n` +
      `Étudiant: ${paiement.etudiant?.nomComplet}\n` +
      `Montant: ${paiement.montant} DH\n` +
      `N° Série: ${paiement.numeroSerie}\n\n` +
      `Cette action est irréversible !`
    );

    if (!confirmation) return;

    try {
      const config = getAuthConfig();
      const response = await fetch(`${API_BASE_URL}/paiements/${paiement._id}`, {
        method: 'DELETE',
        headers: config.headers
      });

      const data = await response.json();

      if (response.ok) {
        alert('✅ Paiement supprimé avec succès');
        fetchPaiements();
      } else {
        alert(`❌ ${data.error || 'Erreur lors de la suppression'}`);
      }
    } catch (err) {
      console.error('Erreur suppression:', err);
      alert('❌ Erreur lors de la suppression du paiement');
    }
  };

  const exportToExcel2025 = async () => {
    try {
      const anneeSelectionnee = filtreAnnee;
      const config = getAuthConfig();

      const resPaiements = await axios.get(`${API_BASE_URL}/paiements`, config);
      const allPaiements = resPaiements.data;

      const resEtudiants = await axios.get(`${API_BASE_URL}/etudiant`, config);
      const etudiants = resEtudiants.data;

      const etudiantMap = new Map();
      etudiants.forEach(e => {
        etudiantMap.set(e._id?.toString(), {
          codeEtudiant: e.codeEtudiant || 'N/A',
          prixTotal: e.prixTotal || 0,
          telephone: e.telephone || 'N/A',
          pays: e.pays || 'N/A',
          observationFinance: e.observationFinance || ''
        });
      });

      const paymentsFor2025 = allPaiements.filter(p => {
        return !anneeSelectionnee || p.etudiant?.anneeScolaire === anneeSelectionnee;
      });

      const studentsForYear = etudiants.filter(e => {
        return !anneeSelectionnee || e.anneeScolaire === anneeSelectionnee;
      });

      if (paymentsFor2025.length === 0 && studentsForYear.length === 0) {
        alert(anneeSelectionnee ? `Aucun paiement ni étudiant trouvé pour l'année ${anneeSelectionnee}` : "Aucun paiement ni étudiant trouvé");
        return;
      }

      // Sort payments: group by student name (alphabetically), then by date of payment (chronological)
      const sortedPaymentsFor2025 = [...paymentsFor2025].sort((a, b) => {
        const nameA = (a.etudiant?.nomComplet || `${a.etudiant?.nomDeFamille || ''} ${a.etudiant?.prenom || ''}`).trim().toLowerCase();
        const nameB = (b.etudiant?.nomComplet || `${b.etudiant?.nomDeFamille || ''} ${b.etudiant?.prenom || ''}`).trim().toLowerCase();
        if (nameA !== nameB) {
          return nameA.localeCompare(nameB);
        }
        const dateA = new Date(a.datePaiement || a.createdAt);
        const dateB = new Date(b.datePaiement || b.createdAt);
        return dateA - dateB;
      });

      const paymentRows = sortedPaymentsFor2025.map(p => {
        const etudiantInfo = etudiantMap.get(p.etudiant?._id?.toString()) || {
          codeEtudiant: 'N/A',
          prixTotal: 0,
          telephone: 'N/A',
          pays: 'N/A'
        };

        const filiere = p.etudiant?.filiere || 'N/A';
        const niveau = p.etudiant?.niveau || 'N/A';
        const specialite =
          p.etudiant?.specialiteIngenieur ||
          p.etudiant?.specialiteLicencePro ||
          p.etudiant?.specialiteMasterPro ||
          p.etudiant?.specialite || 'N/A';
        const option =
          p.etudiant?.optionIngenieur ||
          p.etudiant?.optionLicencePro ||
          p.etudiant?.optionMasterPro ||
          p.etudiant?.option || 'N/A';

        return {
          'Code Étudiant': etudiantInfo.codeEtudiant,
          'Nom Complet': p.etudiant?.nomComplet || `${p.etudiant?.nomDeFamille || ''} ${p.etudiant?.prenom || ''}`.trim() || 'N/A',
          'Nationalité': etudiantInfo.pays || 'N/A',
          'Filière': filiere,
          'Niveau': niveau,
          'Spécialité': specialite,
          'Option': option,
          'Année Scolaire': p.etudiant?.anneeScolaire || 'N/A',
          'Niveau Formation': p.etudiant?.niveauFormation || 'N/A',
          'N° Série': p.numeroSerie || 'N/A',
          'N° Série 2': p.numeroSerieManuel || '—',
          'Montant (DH)': p.montant || 0,
          'Prix Total (DH)': etudiantInfo.prixTotal,
          'Date Début': formatDate(p.moisDebut),
          'Date Fin': calculerDateFin(p.moisDebut, p.nombreMois),
          'Durée (Mois)': p.nombreMois,
          'Mode Paiement': p.modePayment || 'N/A',
          'Date Paiement': formatDate(p.datePaiement || p.createdAt),
          'Note': p.note || '',
          'Observation Financière (Étudiant)': p.etudiant?.observationFinance || etudiantInfo.observationFinance || '',
          'Observation Financière (Paiement)': p.observationFinance || '',
          'Statut Étudiant': p.etudiant?.actif ? 'Actif' : 'Active archivé'
        };
      });

      // Find students who have no payments
      const studentsWithPayments = new Set(paymentsFor2025.map(p => p.etudiant?._id?.toString()).filter(Boolean));
      const studentsWithNoPayments = studentsForYear.filter(e => !studentsWithPayments.has(e._id?.toString()));

      const noPaymentRows = studentsWithNoPayments.map(e => {
        const filiere = e.filiere || 'N/A';
        const niveau = e.niveau || 'N/A';
        const specialite =
          e.specialiteIngenieur ||
          e.specialiteLicencePro ||
          e.specialiteMasterPro ||
          e.specialite || 'N/A';
        const option =
          e.optionIngenieur ||
          e.optionLicencePro ||
          e.optionMasterPro ||
          e.option || 'N/A';

        return {
          'Code Étudiant': e.codeEtudiant || 'N/A',
          'Nom Complet': e.nomComplet || `${e.nomDeFamille || ''} ${e.prenom || ''}`.trim() || 'N/A',
          'Nationalité': e.pays || 'N/A',
          'Filière': filiere,
          'Niveau': niveau,
          'Spécialité': specialite,
          'Option': option,
          'Année Scolaire': e.anneeScolaire || 'N/A',
          'Niveau Formation': e.niveauFormation || 'N/A',
          'N° Série': '—',
          'N° Série 2': '—',
          'Montant (DH)': 0,
          'Prix Total (DH)': e.prixTotal || 0,
          'Date Début': '—',
          'Date Fin': '—',
          'Durée (Mois)': 0,
          'Mode Paiement': '—',
          'Date Paiement': '—',
          'Note': 'Aucun paiement enregistré',
          'Observation Financière (Étudiant)': e.observationFinance || '',
          'Observation Financière (Paiement)': '',
          'Statut Étudiant': e.actif ? 'Actif' : 'Active archivé'
        };
      });

      const combinedRows = [...paymentRows, ...noPaymentRows];

      // Sort combined rows alphabetically by student name
      combinedRows.sort((a, b) => {
        const nameA = (a['Nom Complet'] || '').trim().toLowerCase();
        const nameB = (b['Nom Complet'] || '').trim().toLowerCase();
        if (nameA !== nameB) {
          return nameA.localeCompare(nameB);
        }
        // secondary sort by date
        const dateA = a['Date Paiement'] !== '—' ? new Date(a['Date Paiement'].split('/').reverse().join('-')) : new Date(0);
        const dateB = b['Date Paiement'] !== '—' ? new Date(b['Date Paiement'].split('/').reverse().join('-')) : new Date(0);
        return dateA - dateB;
      });

      const excelData = combinedRows.map((row, index) => {
        return {
          'N°': index + 1,
          ...row
        };
      });

      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet(excelData);

      const colWidths = [
        { wch: 5 }, { wch: 15 }, { wch: 25 }, { wch: 15 }, { wch: 20 }, { wch: 8 }, { wch: 8 }, { wch: 25 },
        { wch: 15 }, { wch: 20 }, { wch: 15 }, { wch: 12 }, { wch: 15 },
        { wch: 12 }, { wch: 12 }, { wch: 8 }, { wch: 15 }, { wch: 15 },
        { wch: 30 }, { wch: 30 }, { wch: 30 }, { wch: 12 }
      ];
      ws['!cols'] = colWidths;

      // --- Style headers and currency columns for payments sheet ---
      try {
        const range0 = XLSX.utils.decode_range(ws['!ref']);
        for (let C = range0.s.c; C <= range0.e.c; ++C) {
          const headerCell = ws[XLSX.utils.encode_cell({ r: range0.s.r, c: C })];
          if (!headerCell) continue;
          headerCell.s = {
            font: { bold: true, color: { rgb: 'FFFFFFFF' } },
            fill: { fgColor: { rgb: 'FF0369A1' } },
            alignment: { horizontal: 'center' }
          };
        }
        // format Montant and Prix Total columns as numbers (cols 11 and 12, 0-based)
        for (let R = range0.s.r + 1; R <= range0.e.r; ++R) {
          [11, 12].forEach((c) => {
            const cellAddr = XLSX.utils.encode_cell({ r: R, c });
            const cell = ws[cellAddr];
            if (cell && typeof cell.v === 'number') {
              cell.t = 'n';
              cell.z = '#,##0';
            }
          });
        }
      } catch (e) {
        // styling best-effort; ignore if any error
        console.warn('Styling payments sheet failed:', e);
      }

      XLSX.utils.book_append_sheet(wb, ws, `Paiements ${anneeSelectionnee ? anneeSelectionnee.replace('/', '-') : 'Tous'}`);

      const etudiantResume = {};

      // Initialize summary for all students in this year
      studentsForYear.forEach(e => {
        const id = e._id?.toString();
        etudiantResume[id] = {
          'Code Étudiant': e.codeEtudiant || 'N/A',
          'Nom Complet': e.nomComplet || `${e.nomDeFamille || ''} ${e.prenom || ''}`.trim() || 'N/A',
          'Téléphone': e.telephone || 'N/A',
          'Nationalité': e.pays || 'N/A',
          'Filière': e.filiere || 'N/A',
          'Niveau': e.niveau || 'N/A',
          'Niveau Formation': e.niveauFormation || 'N/A',
          'Prix Total (DH)': e.prixTotal || 0,
          'Total Payé (DH)': 0,
          'Reste à Payer (DH)': 0,
          'Dernière Date Paiement': '—',
          'Nb Paiements': 0,
          'Statut': e.actif ? 'Actif' : 'Active archivé',
          'Observations': '',
          'Observation Financière': e.observationFinance || '',
          _latestPaymentDateObj: null
        };
      });

      sortedPaymentsFor2025.forEach(p => {
        const id = p.etudiant?._id?.toString();
        if (!id) return;

        if (!etudiantResume[id]) {
          const etInfo = etudiantMap.get(id) || {};
          etudiantResume[id] = {
            'Code Étudiant': etInfo.codeEtudiant || 'N/A',
            'Nom Complet': p.etudiant?.nomComplet || `${p.etudiant?.nomDeFamille || ''} ${p.etudiant?.prenom || ''}`.trim() || 'N/A',
            'Téléphone': p.etudiant?.telephone || etInfo.telephone || 'N/A',
            'Nationalité': etInfo.pays || 'N/A',
            'Filière': p.etudiant?.filiere || 'N/A',
            'Niveau': p.etudiant?.niveau || 'N/A',
            'Niveau Formation': p.etudiant?.niveauFormation || 'N/A',
            'Prix Total (DH)': etInfo.prixTotal || 0,
            'Total Payé (DH)': 0,
            'Reste à Payer (DH)': 0,
            'Dernière Date Paiement': '—',
            'Nb Paiements': 0,
            'Statut': p.etudiant?.actif ? 'Actif' : 'Active archivé',
            'Observations': '',
            'Observation Financière': etInfo.observationFinance || p.etudiant?.observationFinance || '',
            _latestPaymentDateObj: null
          };
        }

        etudiantResume[id]['Total Payé (DH)'] += p.montant || 0;
        etudiantResume[id]['Nb Paiements'] += 1;

        const dateVal = p.datePaiement || p.createdAt;
        if (dateVal) {
          const dateObj = new Date(dateVal);
          if (!etudiantResume[id]._latestPaymentDateObj || dateObj > etudiantResume[id]._latestPaymentDateObj) {
            etudiantResume[id]._latestPaymentDateObj = dateObj;
            etudiantResume[id]['Dernière Date Paiement'] = formatDate(dateVal);
          }
        }

        if (p.note) {
          const existing = etudiantResume[id]['Observations'];
          etudiantResume[id]['Observations'] = existing
            ? `${existing} | ${p.note}`
            : p.note;
        }
      });

      const resumeData = Object.values(etudiantResume).map(e => {
        e['Reste à Payer (DH)'] = Math.max(0, e['Prix Total (DH)'] - e['Total Payé (DH)']);
        delete e._latestPaymentDateObj;
        return e;
      });

      // Sort resumeData alphabetically by student name
      resumeData.sort((a, b) => {
        const nameA = (a['Nom Complet'] || '').trim().toLowerCase();
        const nameB = (b['Nom Complet'] || '').trim().toLowerCase();
        return nameA.localeCompare(nameB);
      });

      const ws2 = XLSX.utils.json_to_sheet(resumeData);
      ws2['!cols'] = [
        { wch: 15 }, { wch: 25 }, { wch: 15 }, { wch: 15 }, { wch: 20 }, { wch: 8 }, { wch: 15 },
        { wch: 15 }, { wch: 15 }, { wch: 15 }, { wch: 22 }, { wch: 12 }, { wch: 10 }, { wch: 40 }
      ];
      XLSX.utils.book_append_sheet(wb, ws2, 'Résumé Étudiants');

      // --- Style headers and totals for résumé sheet ---
      try {
        const range1 = XLSX.utils.decode_range(ws2['!ref']);
        for (let C = range1.s.c; C <= range1.e.c; ++C) {
          const headerCell = ws2[XLSX.utils.encode_cell({ r: range1.s.r, c: C })];
          if (!headerCell) continue;
          headerCell.s = { font: { bold: true }, fill: { fgColor: { rgb: 'FFEEF2CB' } }, alignment: { horizontal: 'center' } };
        }
        // format currency columns: Prix Total (col 7), Total Payé (8), Reste (9)
        for (let R = range1.s.r + 1; R <= range1.e.r; ++R) {
          [7, 8, 9].forEach((c) => {
            const cellAddr = XLSX.utils.encode_cell({ r: R, c });
            const cell = ws2[cellAddr];
            if (cell && typeof cell.v === 'number') {
              cell.t = 'n';
              cell.z = '#,##0';
            }
          });
        }
      } catch (e) {
        console.warn('Styling résumé sheet failed:', e);
      }

      // ===== SHEET 3: STATISTIQUES PAR FILIÈRE =====
      const statsFiliere = {};
      resumeData.forEach(e => {
        const f = e['Filière'] || 'N/A';
        if (!statsFiliere[f]) {
          statsFiliere[f] = {
            'Filière': f,
            'Nb Étudiants': 0,
            'Total Scolarité (DH)': 0,
            'Total Payé (DH)': 0,
            'Total Reste (DH)': 0,
            'Taux Recouvrement (%)': 0,
          };
        }
        statsFiliere[f]['Nb Étudiants'] += 1;
        statsFiliere[f]['Total Scolarité (DH)'] += e['Prix Total (DH)'] || 0;
        statsFiliere[f]['Total Payé (DH)'] += e['Total Payé (DH)'] || 0;
        statsFiliere[f]['Total Reste (DH)'] += e['Reste à Payer (DH)'] || 0;
      });

      const statsData = Object.values(statsFiliere).map(s => {
        s['Taux Recouvrement (%)'] = s['Total Scolarité (DH)'] > 0
          ? Math.round((s['Total Payé (DH)'] / s['Total Scolarité (DH)']) * 100)
          : 0;
        return s;
      }).sort((a, b) => b['Total Payé (DH)'] - a['Total Payé (DH)']);

      // Ajouter ligne TOTAL
      statsData.push({
        'Filière': '📊 TOTAL',
        'Nb Étudiants': resumeData.length,
        'Total Scolarité (DH)': resumeData.reduce((s, e) => s + (e['Prix Total (DH)'] || 0), 0),
        'Total Payé (DH)': resumeData.reduce((s, e) => s + (e['Total Payé (DH)'] || 0), 0),
        'Total Reste (DH)': resumeData.reduce((s, e) => s + (e['Reste à Payer (DH)'] || 0), 0),
        'Taux Recouvrement (%)': Math.round(
          resumeData.reduce((s, e) => s + (e['Total Payé (DH)'] || 0), 0) /
          (resumeData.reduce((s, e) => s + (e['Prix Total (DH)'] || 0), 0) || 1) * 100
        ),
      });

      const ws3 = XLSX.utils.json_to_sheet(statsData);
      ws3['!cols'] = [
        { wch: 25 }, { wch: 15 }, { wch: 20 }, { wch: 18 }, { wch: 18 }, { wch: 22 }
      ];
      XLSX.utils.book_append_sheet(wb, ws3, 'Stats par Filière');

      // --- Style headers and total row for stats sheet ---
      try {
        const range2 = XLSX.utils.decode_range(ws3['!ref']);
        for (let C = range2.s.c; C <= range2.e.c; ++C) {
          const headerCell = ws3[XLSX.utils.encode_cell({ r: range2.s.r, c: C })];
          if (!headerCell) continue;
          headerCell.s = { font: { bold: true }, fill: { fgColor: { rgb: 'FFD1FAFF' } }, alignment: { horizontal: 'center' } };
        }
        // format currency columns: cols 2,3,4
        for (let R = range2.s.r + 1; R <= range2.e.r; ++R) {
          [2, 3, 4].forEach((c) => {
            const cellAddr = XLSX.utils.encode_cell({ r: R, c });
            const cell = ws3[cellAddr];
            if (cell && typeof cell.v === 'number') {
              cell.t = 'n';
              cell.z = '#,##0';
            }
          });
        }
        // bold the last row (TOTAL)
        const totalRow = range2.e.r;
        for (let C = range2.s.c; C <= range2.e.c; ++C) {
          const cell = ws3[XLSX.utils.encode_cell({ r: totalRow, c: C })];
          if (cell) {
            cell.s = { ...(cell.s || {}), font: { ...(cell.s && cell.s.font ? cell.s.font : {}), bold: true }, fill: { fgColor: { rgb: 'FFFFF7E6' } } };
          }
        }
      } catch (e) {
        console.warn('Styling stats sheet failed:', e);
      }

      const today = new Date();
      const anneeLabel = anneeSelectionnee ? anneeSelectionnee.replace('/', '-') : 'Toutes_les_annees';
      const filename = `Paiements_${anneeLabel}_${today.getFullYear()}-${(today.getMonth() + 1).toString().padStart(2, '0')}-${today.getDate().toString().padStart(2, '0')}.xlsx`;

      XLSX.writeFile(wb, filename);
      alert(`✅ Fichier Excel exporté !\n${paymentsFor2025.length} paiements pour ${anneeSelectionnee || 'toutes les années'}`);
    } catch (error) {
      console.error('Erreur export Excel:', error);
      alert('❌ Erreur lors de l\'export Excel');
    }
  };

  const exportToExcelPeriod = async () => {
    try {
      if (filteredPaiements.length === 0) {
        alert('Aucun paiement à exporter.');
        return;
      }

      const config = getAuthConfig();
      const resEtudiants = await axios.get(`${API_BASE_URL}/etudiant`, config);
      const etudiants = resEtudiants.data;

      const etudiantMap = new Map();
      etudiants.forEach(e => {
        etudiantMap.set(e._id?.toString(), {
          codeEtudiant: e.codeEtudiant || 'N/A',
          prixTotal: e.prixTotal || 0,
          telephone: e.telephone || 'N/A',
          pays: e.pays || 'N/A',
          observationFinance: e.observationFinance || ''
        });
      });

      // Sort filtered payments: group by student name (alphabetically), then by date of payment (chronological)
      const sortedPayments = [...filteredPaiements].sort((a, b) => {
        const nameA = (a.etudiant?.nomComplet || `${a.etudiant?.nomDeFamille || ''} ${a.etudiant?.prenom || ''}`).trim().toLowerCase();
        const nameB = (b.etudiant?.nomComplet || `${b.etudiant?.nomDeFamille || ''} ${b.etudiant?.prenom || ''}`).trim().toLowerCase();
        if (nameA !== nameB) {
          return nameA.localeCompare(nameB);
        }
        const dateA = new Date(a.datePaiement || a.createdAt);
        const dateB = new Date(b.datePaiement || b.createdAt);
        return dateA - dateB;
      });

      const paymentRows = sortedPayments.map(p => {
        const etudiantInfo = etudiantMap.get(p.etudiant?._id?.toString()) || {
          codeEtudiant: 'N/A',
          prixTotal: 0,
          telephone: 'N/A',
          pays: 'N/A'
        };

        const filiere = p.etudiant?.filiere || 'N/A';
        const niveau = p.etudiant?.niveau || 'N/A';
        const specialite =
          p.etudiant?.specialiteIngenieur ||
          p.etudiant?.specialiteLicencePro ||
          p.etudiant?.specialiteMasterPro ||
          p.etudiant?.specialite || 'N/A';
        const option =
          p.etudiant?.optionIngenieur ||
          p.etudiant?.optionLicencePro ||
          p.etudiant?.optionMasterPro ||
          p.etudiant?.option || 'N/A';

        return {
          'Code Étudiant': etudiantInfo.codeEtudiant,
          'Nom Complet': p.etudiant?.nomComplet || `${p.etudiant?.nomDeFamille || ''} ${p.etudiant?.prenom || ''}`.trim() || 'N/A',
          'Nationalité': etudiantInfo.pays || 'N/A',
          'Filière': filiere,
          'Niveau': niveau,
          'Spécialité': specialite,
          'Option': option,
          'Année Scolaire': p.etudiant?.anneeScolaire || 'N/A',
          'Niveau Formation': p.etudiant?.niveauFormation || 'N/A',
          'N° Série': p.numeroSerie || 'N/A',
          'N° Série 2': p.numeroSerieManuel || '—',
          'Montant (DH)': p.montant || 0,
          'Prix Total (DH)': etudiantInfo.prixTotal,
          'Date Début': formatDate(p.moisDebut),
          'Date Fin': calculerDateFin(p.moisDebut, p.nombreMois),
          'Durée (Mois)': p.nombreMois,
          'Mode Paiement': p.modePayment || 'N/A',
          'Date Paiement': formatDate(p.datePaiement || p.createdAt),
          'Note': p.note || '',
          'Observation Financière (Étudiant)': p.etudiant?.observationFinance || etudiantInfo.observationFinance || '',
          'Observation Financière (Paiement)': p.observationFinance || '',
          'Statut Étudiant': p.etudiant?.actif ? 'Actif' : 'Active archivé'
        };
      });

      const excelData = paymentRows.map((row, index) => {
        return {
          'N°': index + 1,
          ...row
        };
      });

      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet(excelData);

      const colWidths = [
        { wch: 5 }, { wch: 15 }, { wch: 25 }, { wch: 15 }, { wch: 20 }, { wch: 8 }, { wch: 8 }, { wch: 25 },
        { wch: 15 }, { wch: 20 }, { wch: 15 }, { wch: 12 }, { wch: 15 },
        { wch: 12 }, { wch: 12 }, { wch: 8 }, { wch: 15 }, { wch: 15 },
        { wch: 30 }, { wch: 30 }, { wch: 30 }, { wch: 12 }
      ];
      ws['!cols'] = colWidths;

      try {
        const range0 = XLSX.utils.decode_range(ws['!ref']);
        for (let C = range0.s.c; C <= range0.e.c; ++C) {
          const headerCell = ws[XLSX.utils.encode_cell({ r: range0.s.r, c: C })];
          if (!headerCell) continue;
          headerCell.s = {
            font: { bold: true, color: { rgb: 'FFFFFFFF' } },
            fill: { fgColor: { rgb: 'FF0369A1' } },
            alignment: { horizontal: 'center' }
          };
        }
        for (let R = range0.s.r + 1; R <= range0.e.r; ++R) {
          [11, 12].forEach((c) => {
            const cellAddr = XLSX.utils.encode_cell({ r: R, c });
            const cell = ws[cellAddr];
            if (cell && typeof cell.v === 'number') {
              cell.t = 'n';
              cell.z = '#,##0';
            }
          });
        }
      } catch (e) {
        console.warn('Styling payments sheet failed:', e);
      }

      XLSX.utils.book_append_sheet(wb, ws, 'Détail des encaissements');

      // ===== SHEET 2: RÉSUMÉ PAR ÉTUDIANT (SUR LA PÉRIODE) =====
      const etudiantResume = {};

      sortedPayments.forEach(p => {
        const id = p.etudiant?._id?.toString();
        if (!id) return;

        if (!etudiantResume[id]) {
          const etInfo = etudiantMap.get(id) || {};
          etudiantResume[id] = {
            'Code Étudiant': etInfo.codeEtudiant || 'N/A',
            'Nom Complet': p.etudiant?.nomComplet || `${p.etudiant?.nomDeFamille || ''} ${p.etudiant?.prenom || ''}`.trim() || 'N/A',
            'Téléphone': p.etudiant?.telephone || etInfo.telephone || 'N/A',
            'Nationalité': etInfo.pays || 'N/A',
            'Filière': p.etudiant?.filiere || 'N/A',
            'Niveau': p.etudiant?.niveau || 'N/A',
            'Niveau Formation': p.etudiant?.niveauFormation || 'N/A',
            'Prix Total Scolarité (DH)': etInfo.prixTotal || 0,
            'Total Encaissé Période (DH)': 0,
            'Nb Paiements Période': 0,
            'Date Dernier Paiement Période': '—',
            'Statut': p.etudiant?.actif ? 'Actif' : 'Active archivé',
            'Observations': '',
            'Observation Financière': etInfo.observationFinance || p.etudiant?.observationFinance || '',
            _latestPaymentDateObj: null
          };
        }

        etudiantResume[id]['Total Encaissé Période (DH)'] += p.montant || 0;
        etudiantResume[id]['Nb Paiements Période'] += 1;

        const dateVal = p.datePaiement || p.createdAt;
        if (dateVal) {
          const dateObj = new Date(dateVal);
          if (!etudiantResume[id]._latestPaymentDateObj || dateObj > etudiantResume[id]._latestPaymentDateObj) {
            etudiantResume[id]._latestPaymentDateObj = dateObj;
            etudiantResume[id]['Date Dernier Paiement Période'] = formatDate(dateVal);
          }
        }

        if (p.note) {
          const existing = etudiantResume[id]['Observations'];
          etudiantResume[id]['Observations'] = existing
            ? `${existing} | ${p.note}`
            : p.note;
        }
      });

      const resumeData = Object.values(etudiantResume).map(e => {
        delete e._latestPaymentDateObj;
        return e;
      });

      resumeData.sort((a, b) => {
        const nameA = (a['Nom Complet'] || '').trim().toLowerCase();
        const nameB = (b['Nom Complet'] || '').trim().toLowerCase();
        return nameA.localeCompare(nameB);
      });

      const ws2 = XLSX.utils.json_to_sheet(resumeData);
      ws2['!cols'] = [
        { wch: 15 }, { wch: 25 }, { wch: 15 }, { wch: 15 }, { wch: 20 }, { wch: 8 }, { wch: 15 },
        { wch: 15 }, { wch: 20 }, { wch: 18 }, { wch: 22 }, { wch: 12 }, { wch: 40 }
      ];
      XLSX.utils.book_append_sheet(wb, ws2, 'Résumé par Étudiant');

      try {
        const range1 = XLSX.utils.decode_range(ws2['!ref']);
        for (let C = range1.s.c; C <= range1.e.c; ++C) {
          const headerCell = ws2[XLSX.utils.encode_cell({ r: range1.s.r, c: C })];
          if (!headerCell) continue;
          headerCell.s = { font: { bold: true }, fill: { fgColor: { rgb: 'FFEEF2CB' } }, alignment: { horizontal: 'center' } };
        }
        for (let R = range1.s.r + 1; R <= range1.e.r; ++R) {
          [7, 8].forEach((c) => {
            const cellAddr = XLSX.utils.encode_cell({ r: R, c });
            const cell = ws2[cellAddr];
            if (cell && typeof cell.v === 'number') {
              cell.t = 'n';
              cell.z = '#,##0';
            }
          });
        }
      } catch (e) {
        console.warn('Styling résumé sheet failed:', e);
      }

      // ===== SHEET 3: STATISTIQUES PAR FILIÈRE =====
      const statsFiliere = {};
      resumeData.forEach(e => {
        const f = e['Filière'] || 'N/A';
        if (!statsFiliere[f]) {
          statsFiliere[f] = {
            'Filière': f,
            'Nb Étudiants Actifs Période': 0,
            'Total Encaissé Période (DH)': 0,
          };
        }
        statsFiliere[f]['Nb Étudiants Actifs Période'] += 1;
        statsFiliere[f]['Total Encaissé Période (DH)'] += e['Total Encaissé Période (DH)'] || 0;
      });

      const statsData = Object.values(statsFiliere).sort((a, b) => b['Total Encaissé Période (DH)'] - a['Total Encaissé Période (DH)']);

      statsData.push({
        'Filière': '📊 TOTAL',
        'Nb Étudiants Actifs Période': resumeData.length,
        'Total Encaissé Période (DH)': resumeData.reduce((sum, e) => sum + (e['Total Encaissé Période (DH)'] || 0), 0),
      });

      const ws3 = XLSX.utils.json_to_sheet(statsData);
      ws3['!cols'] = [
        { wch: 25 }, { wch: 20 }, { wch: 22 }
      ];
      XLSX.utils.book_append_sheet(wb, ws3, 'Stats par Filière');

      try {
        const range2 = XLSX.utils.decode_range(ws3['!ref']);
        for (let C = range2.s.c; C <= range2.e.c; ++C) {
          const headerCell = ws3[XLSX.utils.encode_cell({ r: range2.s.r, c: C })];
          if (!headerCell) continue;
          headerCell.s = { font: { bold: true }, fill: { fgColor: { rgb: 'FFD1FAFF' } }, alignment: { horizontal: 'center' } };
        }
        for (let R = range2.s.r + 1; R <= range2.e.r; ++R) {
          const cellAddr = XLSX.utils.encode_cell({ r: R, c: 2 });
          const cell = ws3[cellAddr];
          if (cell && typeof cell.v === 'number') {
            cell.t = 'n';
            cell.z = '#,##0';
          }
        }
        const totalRow = range2.e.r;
        for (let C = range2.s.c; C <= range2.e.c; ++C) {
          const cell = ws3[XLSX.utils.encode_cell({ r: totalRow, c: C })];
          if (cell) {
            cell.s = { ...(cell.s || {}), font: { ...(cell.s && cell.s.font ? cell.s.font : {}), bold: true }, fill: { fgColor: { rgb: 'FFFFF7E6' } } };
          }
        }
      } catch (e) {
        console.warn('Styling stats sheet failed:', e);
      }

      // Nom de fichier avec la période
      let periodLabel = 'Tous';
      if (filters.typePeriode === 'jour' && filters.dateCible) {
        periodLabel = `Jour_${filters.dateCible}`;
      } else if (filters.typePeriode === 'semaine' && filters.dateCible) {
        periodLabel = `Semaine_du_${filters.dateCible}`;
      } else if (filters.typePeriode === 'mois' && filters.moisCible) {
        periodLabel = `Mois_${filters.moisCible}`;
      } else if (filters.typePeriode === 'personnalise') {
        periodLabel = `Perso_${filters.dateDebut || 'debut'}_au_${filters.dateFin || 'fin'}`;
      }

      const today = new Date();
      const filename = `Etat_Encaissements_${periodLabel}_${today.getFullYear()}-${(today.getMonth() + 1).toString().padStart(2, '0')}-${today.getDate().toString().padStart(2, '0')}.xlsx`;

      XLSX.writeFile(wb, filename);
      alert(`✅ Fichier Excel exporté !\n${filteredPaiements.length} paiements exportés pour la période : ${periodLabel}`);
    } catch (error) {
      console.error('Erreur export Excel:', error);
      alert('❌ Erreur lors de l\'export Excel');
    }
  };

  const formatEditorName = (name, userObj) => {
    if (userObj) {
      const p = (userObj.prenom || userObj.firstName || '').trim();
      const n = (userObj.nom || userObj.nomDeFamille || userObj.lastName || '').trim();
      if (p && n && p !== n) {
        return (p[0] + n[0]).toUpperCase();
      }
    }

    if (!name) return 'MS';

    let clean = name.trim();
    if (clean.includes('@')) {
      clean = clean.split('@')[0];
    }
    clean = clean.replace(/[._-]+/g, ' ').trim();

    const parts = clean.split(/\s+/).filter(Boolean);
    if (parts.length >= 2) {
      return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
    }
    if (parts.length === 1) {
      const single = parts[0];
      if (single.length >= 2) {
        return single.slice(0, 2).toUpperCase();
      }
      return single.toUpperCase();
    }
    return 'MS';
  };

  const generatePDF = (p) => {
    // Format A4 Portrait (210 x 297 mm) pour contenir 2 exemplaires sur 1 seule page
    const doc = new jsPDF('portrait', 'mm', 'a4');

    const renderReceipt = (yOffset = 0) => {
      // Couleurs officielles SUP2I
      const primary = [15, 44, 89];      // #0F2C59 Bleu Nuit officiel SUP2I
      const royalBlue = [27, 85, 175];   // #1B55AF Bleu Royal
      const accentRed = [220, 38, 38];    // #DC2626 Rouge Reçu N° et Avertissement
      const textDark = [31, 41, 55];      // #1F2937 Texte sombre
      const textMuted = [107, 114, 128];  // #6B7280 Texte gris
      const lineGrey = [209, 213, 219];   // #D1D5DB Ligne discrète
      const bgLight = [248, 250, 252];    // #F8FAFC Fond clair

      // 1. Cadre général professionnel (double filet élégant)
      doc.setDrawColor(...primary);
      doc.setLineWidth(1.1);
      doc.roundedRect(4, 4 + yOffset, 202, 92, 2, 2, 'D');

      doc.setDrawColor(...royalBlue);
      doc.setLineWidth(0.3);
      doc.roundedRect(5.2, 5.2 + yOffset, 199.6, 89.6, 1.5, 1.5, 'D');

      // 2. LOGO OFFICIEL SUP2I
      try {
        doc.addImage(SUP2I_LOGO_BASE64, 'PNG', 8, 6.5 + yOffset, 46, 15.5);
      } catch (e) {
        doc.setTextColor(...primary);
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(16);
        doc.text('SUP2I', 21, 14 + yOffset);
        doc.setTextColor(...textMuted);
        doc.setFontSize(7.5);
        doc.text("Reconnue par l'État", 21, 18.5 + yOffset);
      }

      // Bloc en-tête droit : REÇU DE PAIEMENT
      doc.setTextColor(...primary);
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(13);
      doc.text('REÇU DE PAIEMENT', 152, 10 + yOffset, { align: 'center' });

      // Année universitaire
      const anneeUniv = p.etudiant?.anneeScolaire || '2026/2027';
      doc.setTextColor(...royalBlue);
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(8.5);
      doc.text(`Année universitaire ${anneeUniv}`, 152, 14 + yOffset, { align: 'center' });

      // Reçu N°
      const receiptNum = p.numeroSerie || (p._id ? p._id.toString().slice(-6) : `00${Date.now().toString().slice(-4)}`);
      doc.setTextColor(...textDark);
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(9);
      doc.text('Reçu N° : ', 138, 18.2 + yOffset);
      doc.setTextColor(...accentRed);
      doc.setFontSize(10.5);
      doc.text(`${receiptNum}`, 154, 18.2 + yOffset);

      if (p.numeroSerieManuel) {
        doc.setTextColor(55, 65, 81);
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(9);
        doc.text(`${p.numeroSerieManuel}`, 154, 22.2 + yOffset);
      }

      // Ligne de séparation sous l'en-tête
      doc.setDrawColor(...royalBlue);
      doc.setLineWidth(0.6);
      doc.line(8, 24 + yOffset, 202, 24 + yOffset);

      // Données de l'étudiant
      const studentName = (
        p.etudiant?.nomComplet ||
        (p.etudiant ? `${p.etudiant.nomDeFamille || ''} ${p.etudiant.prenom || ''}`.trim() : '') ||
        '_________________________________'
      ).toUpperCase();

      const montantVal = Number(p.montant) || 0;
      const montantLettres = nombreEnLettres(montantVal);

      // --- Ligne 1 : Reçu de: Mr/Mme ---
      let y = 29.5 + yOffset;
      doc.setTextColor(...textDark);
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(9);
      doc.text('Reçu de: Mr/Mme', 10, y);

      doc.setTextColor(...primary);
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(10);
      doc.text(studentName, 43, y);

      // Ligne pointillée
      doc.setDrawColor(...lineGrey);
      doc.setLineWidth(0.3);
      doc.setLineDashPattern([0.8, 0.8], 0);
      doc.line(43, y + 1.2, 200, y + 1.2);
      doc.setLineDashPattern([], 0); // reset

      // --- Ligne 2 : La somme de : ---
      y = 36.5 + yOffset;
      doc.setTextColor(...textDark);
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(9);
      doc.text('La somme de :', 10, y);

      doc.setTextColor(17, 24, 39);
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(9);
      const sommeComplete = `${montantLettres} (${montantVal} DH)`;
      doc.text(sommeComplete, 38, y);

      doc.setDrawColor(...lineGrey);
      doc.setLineWidth(0.3);
      doc.setLineDashPattern([0.8, 0.8], 0);
      doc.line(38, y + 1.2, 200, y + 1.2);
      doc.setLineDashPattern([], 0);

      // --- Bloc intermédiaire (En règlement des VS Observation) ---
      const isInscription = Boolean(
        p.estInscription ||
        p.typePaiement === 'inscription' ||
        (p.note && p.note.toLowerCase().includes('inscription'))
      );
      const isScolarite = !isInscription;

      // Colonne gauche : En règlement des
      doc.setTextColor(...textDark);
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(8.5);
      doc.text('En règlement des :', 10, 45 + yOffset);

      // Helper pour case à cocher
      const drawBoxWithCheck = (x, boxY, checked, label) => {
        doc.setDrawColor(...primary);
        doc.setLineWidth(0.4);
        doc.rect(x, boxY, 3.2, 3.2);

        if (checked) {
          doc.setDrawColor(...royalBlue);
          doc.setLineWidth(0.7);
          // Checkmark
          doc.line(x + 0.6, boxY + 1.8, x + 1.3, boxY + 2.7);
          doc.line(x + 1.3, boxY + 2.7, x + 2.8, boxY + 0.6);
        }

        doc.setTextColor(...textDark);
        doc.setFont('helvetica', checked ? 'bold' : 'normal');
        doc.setFontSize(8);
        doc.text(label, x + 4.8, boxY + 2.6);
      };

      drawBoxWithCheck(43, 43.5 + yOffset, isInscription, "Frais d'inscription");
      drawBoxWithCheck(43, 50.5 + yOffset, isScolarite, 'Frais de scolarité');

      // Colonne droite : Cadre Observation
      doc.setDrawColor(...primary);
      doc.setLineWidth(0.5);
      doc.setFillColor(...bgLight);
      doc.roundedRect(108, 40.5 + yOffset, 92, 17, 1.5, 1.5, 'FD');

      doc.setTextColor(...primary);
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(8);
      doc.text('Observation :', 111, 44.5 + yOffset);

      // Ligne 1 observation : Niveau & Filière
      const niveau = p.etudiant?.niveau ? `${p.etudiant.niveau}${p.etudiant.niveau === 1 ? 'ère' : 'ème'} Année` : '';
      const filiere = p.etudiant?.filiere || '';
      const coursStr = Array.isArray(p.cours) ? p.cours.join(', ') : (p.cours || '');
      const filiereInfo = [niveau, filiere, coursStr].filter(Boolean).join(' - ');

      doc.setTextColor(...textDark);
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(8);
      doc.text(filiereInfo.length > 52 ? filiereInfo.substring(0, 52) + '...' : filiereInfo, 111, 49.5 + yOffset);

      // Ligne 2 observation : Période / Tranche / Note
      let obsSub = '';
      if (p.note && p.note.trim() !== '') {
        obsSub = p.note;
      } else if (p.moisDebut) {
        obsSub = `Période: ${formatDate(p.moisDebut)} (${p.nombreMois || 1} mois)`;
      }
      if (obsSub) {
        doc.setFont('helvetica', 'normal');
        doc.setFontSize(7.5);
        doc.setTextColor(...textMuted);
        doc.text(obsSub.length > 55 ? obsSub.substring(0, 55) + '...' : obsSub, 111, 54.5 + yOffset);
      }

      // --- Ligne 4 : Mode de règlement ---
      y = 61.5 + yOffset;
      doc.setTextColor(...textDark);
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(8);
      doc.text('Mode de règlement :', 8.5, y);

      const modeStr = (p.modePayment || p.modePaiement || '').toLowerCase();
      const isEsp = modeStr.includes('esp') || (!modeStr && true);
      const isVir = modeStr.includes('vir');
      const isCheq = modeStr.includes('ch');
      const isVers = modeStr.includes('vers');

      // Récupération ou extraction banque & numéro de chèque si disponible
      let bqVal = p.banque || '';
      let numVal = p.numeroCheque || p.numCheque || '';
      const combinedText = `${p.note || ''} ${p.observationFinance || ''}`.trim();
      if (!bqVal && combinedText) {
        const bqMatch = combinedText.match(/(?:banque|bq)[:\s]+([A-Za-z0-9\s]+?)(?:[-,\n]|$|n[°o])/i) ||
          combinedText.match(/\b(attijari(?:wafa)?|bmce|boa|cih|chaabi|banque populaire|bp|sgmb|societe generale|cdg|credit agricole|cam|bmci)\b/i);
        if (bqMatch) bqVal = bqMatch[1].trim();
      }
      if (!numVal && combinedText) {
        const numMatch = combinedText.match(/(?:n[°o]|num[eé]ro|ch[eè]que\s*n[°o]?)[:\s]*([A-Za-z0-9]+)/i);
        if (numMatch) numVal = numMatch[1].trim();
      }

      let currX = 38.5;
      doc.setFontSize(7.5);

      // 1. Espèces
      drawBoxWithCheck(currX, y - 2.5, isEsp, 'Espèces');
      doc.setFont('helvetica', isEsp ? 'bold' : 'normal');
      currX += 4.5 + doc.getTextWidth('Espèces') + 3.5;

      // 2. Virement : Date
      drawBoxWithCheck(currX, y - 2.5, isVir, 'Virement');
      doc.setFont('helvetica', isVir ? 'bold' : 'normal');
      currX += 4.5 + doc.getTextWidth('Virement') + 1.2;

      doc.setFont('helvetica', 'normal');
      doc.setTextColor(...textDark);
      doc.text('Date :', currX, y);
      currX += doc.getTextWidth('Date :') + 1;

      const virDateStr = isVir ? formatDate(p.dateVirement || p.datePaiement || p.createdAt) : '...........';
      doc.setFont('helvetica', isVir ? 'bold' : 'normal');
      doc.setTextColor(...(isVir ? primary : textMuted));
      doc.text(virDateStr, currX, y);
      currX += doc.getTextWidth(virDateStr) + 3.5;

      // 3. Chèque : Banque & N°
      drawBoxWithCheck(currX, y - 2.5, isCheq, 'Chèque');
      doc.setFont('helvetica', isCheq ? 'bold' : 'normal');
      currX += 4.5 + doc.getTextWidth('Chèque') + 1.2;

      doc.setFont('helvetica', 'normal');
      doc.setTextColor(...textDark);
      doc.text('Banque :', currX, y);
      currX += doc.getTextWidth('Banque :') + 1;

      const bqStr = (isCheq && bqVal) ? bqVal : '.........';
      doc.setFont('helvetica', isCheq && bqVal ? 'bold' : 'normal');
      doc.setTextColor(...(isCheq && bqVal ? primary : textMuted));
      doc.text(bqStr, currX, y);
      currX += doc.getTextWidth(bqStr) + 2;

      doc.setFont('helvetica', 'normal');
      doc.setTextColor(...textDark);
      doc.text('N° :', currX, y);
      currX += doc.getTextWidth('N° :') + 1;

      const numStr = (isCheq && numVal) ? numVal : '.........';
      doc.setFont('helvetica', isCheq && numVal ? 'bold' : 'normal');
      doc.setTextColor(...(isCheq && numVal ? primary : textMuted));
      doc.text(numStr, currX, y);
      currX += doc.getTextWidth(numStr) + 3.5;

      // 4. Versement : Date
      drawBoxWithCheck(currX, y - 2.5, isVers, 'Versement');
      doc.setFont('helvetica', isVers ? 'bold' : 'normal');
      currX += 4.5 + doc.getTextWidth('Versement') + 1.2;

      doc.setFont('helvetica', 'normal');
      doc.setTextColor(...textDark);
      doc.text('Date :', currX, y);
      currX += doc.getTextWidth('Date :') + 1;

      const versDateStr = isVers ? formatDate(p.dateVersement || p.datePaiement || p.createdAt) : '...........';
      doc.setFont('helvetica', isVers ? 'bold' : 'normal');
      doc.setTextColor(...(isVers ? primary : textMuted));
      doc.text(versDateStr, currX, y);

      // --- Section Inférieure ---
      // Date
      y = 68.5 + yOffset;
      doc.setTextColor(...textDark);
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(8);
      doc.text('À : Casablanca, le :', 10, y);
      doc.setFont('helvetica', 'normal');
      doc.text(formatDate(p.datePaiement || p.createdAt || new Date()), 41, y);

      // Case "Édité par ........." (Demande Khadija Finance)
      const userStorageStr = localStorage.getItem('user');
      const currentUser = userStorageStr ? JSON.parse(userStorageStr) : null;
      const currentUserName = (currentUser?.prenom && (currentUser?.nom || currentUser?.nomDeFamille))
        ? `${currentUser.prenom} ${currentUser.nom || currentUser.nomDeFamille}`
        : (currentUser?.nomComplet || currentUser?.nom || currentUser?.prenom || (currentUser?.email ? currentUser.email.split('@')[0] : ''));

      const rawEditorName = p.creeParNom || (p.creePar && typeof p.creePar === 'object' ? (p.creePar.nomComplet || `${p.creePar.prenom || ''} ${p.creePar.nom || ''}`.trim() || p.creePar.nom) : null) || currentUserName;
      const editorName = formatEditorName(rawEditorName, currentUser);

      // Encadré officiel "Édité par"
      doc.setFillColor(243, 244, 246);
      doc.setDrawColor(209, 213, 219);
      doc.setLineWidth(0.4);
      doc.roundedRect(10, 71.5 + yOffset, 78, 6.5, 1, 1, 'FD');

      doc.setTextColor(...primary);
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(7.5);
      doc.text('Édité par :', 12, 75.8 + yOffset);

      doc.setTextColor(...textDark);
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(7.5);
      doc.text(editorName, 28, 75.8 + yOffset);

      // Avertissement OBLIGATOIRE (Demande utilisateur)
      doc.setTextColor(...accentRed);
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(7.5);
      doc.text("NB : Les frais d'inscription ne sont pas remboursables", 10, 83 + yOffset);

      // Administration SUP2I / Signature & Cachet
      doc.setTextColor(...primary);
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(8);
      doc.text('Administration SUP2I :', 135, 68 + yOffset);

      doc.setDrawColor(...royalBlue);
      doc.setLineWidth(0.5);
      doc.roundedRect(135, 70 + yOffset, 65, 14, 1.5, 1.5, 'D');

      doc.setTextColor(...textMuted);
      doc.setFont('helvetica', 'italic');
      doc.setFontSize(7);
      doc.text('Signature & Cachet', 167.5, 77.5 + yOffset, { align: 'center' });

      // --- BANDEAU INFÉRIEUR (Bleu SUP2I comme sur le reçu papier) ---
      doc.setFillColor(...primary);
      doc.rect(4.5, 87.5 + yOffset, 201, 8.5, 'F');

      doc.setTextColor(255, 255, 255);
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(7.5);
      doc.text("SUP2I  |  Reconnue par l'État", 9, 92 + yOffset);

      doc.setFont('helvetica', 'normal');
      doc.setFontSize(6.2);
      doc.text('1 bld El Yazidi - Ain Sebaa - Casablanca  •  Tél : +212 (0) 522 249 175', 198, 91 + yOffset, { align: 'right' });
      doc.setTextColor(191, 219, 254);
      doc.text('E-mail : infos@sup2i.ac  •  www.sup2i.ac', 198, 94.5 + yOffset, { align: 'right' });
    };

    // Exemplaire 1 (Haut de la page)
    renderReceipt(0);

    // Ligne de découpe au milieu de la page A4 (Y = 120 mm)
    doc.setDrawColor(180, 180, 180);
    doc.setLineWidth(0.3);
    doc.setLineDashPattern([2, 2], 0);
    doc.line(4, 120, 206, 120);
    doc.setLineDashPattern([], 0);

    doc.setTextColor(120, 120, 120);
    doc.setFont('helvetica', 'italic');
    doc.setFontSize(7);
    doc.text('------------------ Découper ici / Cut here ------------------', 105, 119, { align: 'center' });

    // Exemplaire 2 (Bas de la page)
    renderReceipt(138);

    doc.autoPrint();
    window.open(doc.output('bloburl'), '_blank');
  };

  const openDetailModal = (paiement) => {
    setSelectedPaiement(paiement);
    setShowDetailModal(true);
  };

  const closeDetailModal = () => {
    setShowDetailModal(false);
    setSelectedPaiement(null);
  };

  const CardView = ({ paiement }) => (
    <div style={styles.card}>
      <div style={styles.cardHeader}>
        <div style={styles.cardUserInfo}>
          <div style={styles.avatar}>
            <User size={24} color="white" />
          </div>
          <div>
            <h3 style={styles.cardUserName}>
              {paiement.etudiant?.nomComplet ||
                (paiement.etudiant ? `${paiement.etudiant.nomDeFamille || ''} ${paiement.etudiant.prenom || ''}`.trim() : '—')}
              {paiement.etudiant?.codeEtudiant ? ` (${paiement.etudiant.codeEtudiant})` : ''}
              {paiement.etudiant && !paiement.etudiant.actif && (
                <span style={{
                  marginLeft: '8px',
                  fontSize: '10px',
                  backgroundColor: '#EF4444',
                  color: 'white',
                  padding: '2px 6px',
                  borderRadius: '4px',
                  fontWeight: '600',
                  display: 'inline-block',
                  verticalAlign: 'middle'
                }}>
                  Archivé
                </span>
              )}
            </h3>
            <p style={styles.cardCourse}>
              <BookOpen size={16} style={{ marginRight: '4px' }} />
              {paiement.isDummy
                ? (paiement.etudiant?.filiere || 'Aucune filière')
                : (Array.isArray(paiement.cours) ? paiement.cours.join(', ') : paiement.cours)}
            </p>
          </div>
        </div>
        <div style={{ display: 'flex', gap: '8px' }}>
          {paiement.isDummy ? (
            <>
              {!isHiba && (
                <button
                  onClick={() => payerEtudiant(paiement.etudiant?._id, paiement.etudiant?.cours)}
                  style={{
                    padding: '6px 12px',
                    backgroundColor: '#059669',
                    color: 'white',
                    border: 'none',
                    borderRadius: '6px',
                    cursor: 'pointer',
                    fontSize: '13px',
                    fontWeight: '600',
                  }}
                  title="Enregistrer un paiement"
                >
                  💰 Payer
                </button>
              )}
              {canEditObs && (
                <button
                  onClick={() => openObsModal(paiement)}
                  style={{ ...styles.cardPdfButton, backgroundColor: '#F3E8FF', color: '#8B5CF6' }}
                  title="Modifier l'observation financière"
                >
                  <FileText size={20} />
                </button>
              )}
            </>
          ) : (
            <>
              <button onClick={() => generatePDF(paiement)} style={styles.cardPdfButton} title="Télécharger PDF">
                <Download size={20} />
              </button>
              {!isHiba && (
                <button onClick={() => openEditModal(paiement)} style={{ ...styles.cardPdfButton, backgroundColor: '#FEF3C7', color: '#F59E0B' }} title="Modifier">
                  <Edit size={20} />
                </button>
              )}
              {canEditObs && (
                <button onClick={() => openObsModal(paiement)} style={{ ...styles.cardPdfButton, backgroundColor: '#F3E8FF', color: '#8B5CF6' }} title="Modifier l'observation financière">
                  <FileText size={20} />
                </button>
              )}
              {!isHiba && (
                <button onClick={() => handleDelete(paiement)} style={{ ...styles.cardPdfButton, backgroundColor: '#FEE2E2', color: '#EF4444' }} title="Supprimer">
                  <Trash2 size={20} />
                </button>
              )}
            </>
          )}
        </div>
      </div>

      <div style={styles.cardGrid}>
        <div style={styles.cardInfoItem}>
          <DollarSign size={16} color={paiement.isDummy ? '#EF4444' : '#10B981'} />
          <span style={styles.cardLabel}>Montant:</span>
          <span style={paiement.isDummy ? { ...styles.cardAmount, color: '#EF4444' } : styles.cardAmount}>
            {paiement.isDummy ? '0 Dh (Non payé)' : `${paiement.montant} Dh`}
          </span>
        </div>
        <div style={styles.cardInfoItem}>
          <Calendar size={16} color="#3B82F6" />
          <span style={styles.cardLabel}>Durée:</span>
          <span style={styles.cardValue}>{paiement.isDummy ? '—' : `${paiement.nombreMois} mois`}</span>
        </div>
      </div>

      <div style={styles.cardDetails}>
        {!paiement.isDummy && paiement.numeroSerie && (
          <div style={styles.cardDetailRow}>
            <span style={styles.cardDetailLabel}>N° Série:</span>
            <span style={{ ...styles.cardDetailValue, fontFamily: 'monospace', fontSize: '12px' }}>{paiement.numeroSerie}</span>
          </div>
        )}
        {!paiement.isDummy && paiement.numeroSerieManuel && (
          <div style={styles.cardDetailRow}>
            <span style={styles.cardDetailLabel}>N° Série 2:</span>
            <span style={{ ...styles.cardDetailValue, fontFamily: 'monospace', fontSize: '12px', color: '#4f46e5' }}>{paiement.numeroSerieManuel}</span>
          </div>
        )}
        <div style={styles.cardDetailRow}>
          <span style={styles.cardDetailLabel}>Début:</span>
          <span style={styles.cardDetailValue}>{paiement.isDummy ? '—' : formatDate(paiement.moisDebut)}</span>
        </div>
        <div style={styles.cardDetailRow}>
          <span style={styles.cardDetailLabel}>Payé le:</span>
          <span style={styles.cardDetailValue}>{paiement.isDummy ? '—' : formatDate(paiement.datePaiement || paiement.createdAt)}</span>
        </div>
        {paiement.etudiant?.niveauFormation && (
          <div style={styles.cardDetailRow}>
            <span style={styles.cardDetailLabel}>Niveau Formation:</span>
            <span style={styles.cardDetailValue}>{paiement.etudiant.niveauFormation}</span>
          </div>
        )}
        <div style={styles.cardDetailRow}>
          <span style={styles.cardDetailLabel}>Mode:</span>
          <span style={{
            ...styles.cardDetailValue,
            color: paiement.isDummy ? '#EF4444' : '#111827',
            fontWeight: paiement.isDummy ? '600' : '500'
          }}>{paiement.modePayment}</span>
        </div>
        {paiement.note && (
          <div style={styles.cardNote}>
            <span style={styles.cardDetailLabel}>Note:</span>
            <p style={styles.cardNoteText}>{paiement.note}</p>
          </div>
        )}
      </div>
    </div>
  );

  const styles = {
    container: {
      minHeight: '100vh',
      backgroundImage: 'linear-gradient(135deg, #f0f9ff 0%, #a6dbff 25%, #f3e8ff 100%)',
      padding: '24px',
    },
    maxWidth: {
      maxWidth: 'none',
      width: '100%',
      margin: '0',
      padding: '0 12px',
    },
    header: {
      backgroundColor: 'white',
      borderRadius: '1rem',
      padding: '1.5rem',
      marginBottom: '2rem',
      boxShadow: '0 10px 15px rgba(0, 0, 0, 0.05)',
      textAlign: 'center',
    },
    title: {
      fontSize: '32px',
      fontWeight: 'bold',
      margin: 0,
      color: '#1f2937'
    },
    controlsContainer: {
      background: 'white',
      borderRadius: '12px',
      boxShadow: '0 10px 25px rgba(0, 0, 0, 0.1)',
      padding: '24px',
      marginBottom: '24px',
    },
    controlsRow: {
      display: 'flex',
      gap: '16px',
      alignItems: 'center',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
    },
    searchContainer: {
      position: 'relative',
      flex: '1',
      maxWidth: '400px',
    },
    searchInput: {
      width: '100%',
      paddingLeft: '40px',
      paddingRight: '16px',
      paddingTop: '12px',
      paddingBottom: '12px',
      border: '1px solid #E5E7EB',
      borderRadius: '8px',
      fontSize: '16px',
      outline: 'none',
    },
    searchIcon: {
      position: 'absolute',
      left: '12px',
      top: '50%',
      transform: 'translateY(-50%)',
      color: '#9CA3AF',
    },
    controlsRight: {
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
    },
    viewToggle: {
      display: 'flex',
      background: '#F3F4F6',
      borderRadius: '8px',
      padding: '4px',
    },
    viewButton: {
      padding: '8px',
      borderRadius: '6px',
      border: 'none',
      background: 'transparent',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
    },
    viewButtonActive: {
      background: 'white',
      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
      color: '#3B82F6',
    },
    alertButton: {
      background: 'linear-gradient(135deg, #F59E0B 0%, #EF4444 100%)',
      color: 'white',
      padding: '12px 24px',
      borderRadius: '8px',
      border: 'none',
      cursor: 'pointer',
      fontWeight: '500',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
    },
    resultsCount: {
      marginBottom: '24px',
      color: '#6B7280',
    },
    tableContainer: {
      background: 'white',
      borderRadius: '12px',
      boxShadow: '0 10px 25px rgba(0, 0, 0, 0.1)',
      overflow: 'hidden',
    },
    table: {
      width: '100%',
      borderCollapse: 'collapse',
    },
    thead: {
      background: 'linear-gradient(135deg, #F9FAFB 0%, #E0F2FE 100%)',
    },
    th: {
      padding: '16px 24px',
      textAlign: 'left',
      fontSize: '14px',
      fontWeight: '600',
      color: '#111827',
      borderBottom: '1px solid #E5E7EB',
    },
    td: {
      padding: '16px 24px',
      color: '#374151',
      borderBottom: '1px solid #F3F4F6',
    },
    userCell: {
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
    },
    tableAvatar: {
      width: '32px',
      height: '32px',
      background: 'linear-gradient(135deg, #3B82F6 0%, #8B5CF6 100%)',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    userName: {
      fontWeight: '500',
      color: '#111827',
    },
    durationBadge: {
      background: '#DBEAFE',
      color: '#1E40AF',
      padding: '4px 12px',
      borderRadius: '20px',
      fontSize: '14px',
      fontWeight: '500',
    },
    amount: {
      color: '#059669',
      fontWeight: '600',
    },
    actionButton: {
      padding: '8px',
      borderRadius: '6px',
      border: 'none',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    cardsGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(350px, 1fr))',
      gap: '24px',
    },
    card: {
      background: 'white',
      borderRadius: '12px',
      boxShadow: '0 10px 25px rgba(0, 0, 0, 0.1)',
      padding: '24px',
      border: '1px solid #E5E7EB',
    },
    cardHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      marginBottom: '16px',
    },
    cardUserInfo: {
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
    },
    avatar: {
      width: '48px',
      height: '48px',
      background: 'linear-gradient(135deg, #3B82F6 0%, #8B5CF6 100%)',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    cardUserName: {
      fontWeight: '600',
      color: '#111827',
      margin: '0 0 4px 0',
      fontSize: '16px',
    },
    cardCourse: {
      fontSize: '14px',
      color: '#6B7280',
      display: 'flex',
      alignItems: 'center',
      margin: 0,
    },
    cardPdfButton: {
      padding: '8px',
      background: '#EFF6FF',
      border: 'none',
      borderRadius: '6px',
      cursor: 'pointer',
      color: '#3B82F6',
    },
    cardGrid: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: '16px',
      marginBottom: '16px',
    },
    cardInfoItem: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
    },
    cardLabel: {
      fontSize: '14px',
      color: '#6B7280',
    },
    cardAmount: {
      fontWeight: '500',
      color: '#059669',
    },
    cardValue: {
      fontWeight: '500',
      color: '#111827',
    },
    cardDetails: {
      borderTop: '1px solid #F3F4F6',
      paddingTop: '16px',
    },
    cardDetailRow: {
      display: 'flex',
      justifyContent: 'space-between',
      marginBottom: '8px',
      fontSize: '14px',
    },
    cardDetailLabel: {
      color: '#6B7280',
    },
    cardDetailValue: {
      fontWeight: '500',
      color: '#111827',
    },
    cardNote: {
      borderTop: '1px solid #F3F4F6',
      paddingTop: '12px',
      marginTop: '12px',
    },
    cardNoteText: {
      color: '#111827',
      marginTop: '4px',
      fontSize: '14px',
    },
    modal: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '16px',
      zIndex: 1000,
    },
    modalContent: {
      background: 'white',
      borderRadius: '16px',
      boxShadow: '0 25px 50px rgba(0, 0, 0, 0.25)',
      maxWidth: '600px',
      width: '100%',
      maxHeight: '80vh',
      overflow: 'hidden',
    },
    modalHeader: {
      background: 'linear-gradient(135deg, #F59E0B 0%, #EF4444 100%)',
      color: 'white',
      padding: '24px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    modalTitle: {
      fontSize: '20px',
      fontWeight: 'bold',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      margin: 0,
    },
    modalBody: {
      padding: '24px',
      overflowY: 'auto',
      maxHeight: '500px',
    },
    editModalHeader: {
      background: 'linear-gradient(135deg, #F59E0B 0%, #F97316 100%)',
      color: 'white',
      padding: '24px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    formGroup: {
      marginBottom: '20px',
    },
    label: {
      display: 'block',
      marginBottom: '8px',
      fontWeight: '500',
      color: '#374151',
      fontSize: '14px',
    },
    input: {
      width: '100%',
      padding: '12px',
      border: '1px solid #D1D5DB',
      borderRadius: '8px',
      fontSize: '14px',
      outline: 'none',
      boxSizing: 'border-box',
    },
    textarea: {
      width: '100%',
      padding: '12px',
      border: '1px solid #D1D5DB',
      borderRadius: '8px',
      fontSize: '14px',
      outline: 'none',
      resize: 'vertical',
      minHeight: '80px',
      fontFamily: 'inherit',
      boxSizing: 'border-box',
    },
    buttonGroup: {
      display: 'flex',
      gap: '12px',
      marginTop: '24px',
      paddingTop: '16px',
      borderTop: '1px solid #E5E7EB',
    },
    saveButton: {
      flex: 1,
      padding: '12px 20px',
      background: '#10B981',
      color: 'white',
      border: 'none',
      borderRadius: '8px',
      cursor: 'pointer',
      fontWeight: '500',
      fontSize: '14px',
    },
    cancelButton: {
      flex: 1,
      padding: '12px 20px',
      background: '#F3F4F6',
      color: '#374151',
      border: 'none',
      borderRadius: '8px',
      cursor: 'pointer',
      fontWeight: '500',
      fontSize: '14px',
    },
    closeButton: {
      color: 'white',
      background: 'rgba(255, 255, 255, 0.2)',
      border: 'none',
      padding: '8px',
      borderRadius: '6px',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
  };

  // ✅ AJOUTÉ : Nombre de filtres actifs et réinitialisation
  const getActiveFiltersCount = () => {
    let count = 0;
    if (filters.typePeriode !== 'tous') count++;
    if (filters.montantMin) count++;
    if (filters.montantMax) count++;
    if (filters.modePayment) count++;
    return count;
  };

  const resetFilters = () => {
    setFilters({
      typePeriode: 'tous',
      dateCible: '',
      moisCible: '',
      dateDebut: '',
      dateFin: '',
      montantMin: '',
      montantMax: '',
      modePayment: ''
    });
    setSearchTerm('');
    setFilterNiveauFormation('');
    setFiltreAnnee('');
    setFilterStatut('actifs');
  };

  return (
    <div style={styles.container}>
      <Sidebar onLogout={handleLogout} />
      <div style={styles.maxWidth}>
        <div style={styles.header}>
          <h1 style={styles.title}>Liste des Paiements</h1>
        </div>

        <div style={styles.controlsContainer}>
          <div style={styles.controlsRow}>
            <div style={styles.searchContainer}>
              <div style={styles.searchIcon}>
                <Search size={20} />
              </div>
              <input
                type="text"
                placeholder="Rechercher par nom, classe, n° série..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={styles.searchInput}
              />
            </div>

            {/* ✅ AJOUTÉ : Filtre par niveau de formation */}
            <select
              value={filterNiveauFormation}
              onChange={(e) => setFilterNiveauFormation(e.target.value)}
              style={{
                padding: '12px 16px',
                border: '1px solid #E5E7EB',
                borderRadius: '8px',
                fontSize: '14px',
                outline: 'none',
                cursor: 'pointer',
                backgroundColor: 'white',
                color: filterNiveauFormation ? '#111827' : '#9CA3AF',
                minWidth: '200px',
              }}
            >
              <option value="">Tous les niveaux</option>
              {niveauxFormation.map(n => (
                <option key={n} value={n}>{n}</option>
              ))}
            </select>

            <select
              value={filtreAnnee}
              onChange={(e) => setFiltreAnnee(e.target.value)}
              style={{
                padding: '12px 16px',
                border: '1px solid #E5E7EB',
                borderRadius: '8px',
                fontSize: '14px',
                outline: 'none',
                cursor: 'pointer',
                backgroundColor: 'white',
                color: filtreAnnee ? '#111827' : '#9CA3AF',
                minWidth: '180px',
              }}
            >
              <option value="">Toutes les années</option>
              <option value="2024/2025">2024/2025</option>
              <option value="2025/2026">2025/2026</option>
              <option value="2026/2027">2026/2027</option>
            </select>

            <select
              value={filterStatut}
              onChange={(e) => setFilterStatut(e.target.value)}
              style={{
                padding: '12px 16px',
                border: '1px solid #E5E7EB',
                borderRadius: '8px',
                fontSize: '14px',
                outline: 'none',
                cursor: 'pointer',
                backgroundColor: 'white',
                color: '#111827',
                minWidth: '180px',
              }}
            >
              <option value="tous">Tous les statuts</option>
              <option value="actifs">Étudiants actifs</option>
              <option value="inactifs">Étudiants archivés (inactifs)</option>
            </select>

            <div style={styles.controlsRight}>
              <button
                onClick={exportToExcel2025}
                style={{
                  ...styles.alertButton,
                  background: 'linear-gradient(135deg, #10B981 0%, #059669 100%)',
                }}
                title="Exporter vers Excel"
              >
                <FileSpreadsheet size={20} />
                <span>Excel {filtreAnnee || '2025/2026'}</span>
              </button>

              {/* ✅ AJOUTÉ : Nouveau bouton d'export Excel par période */}
              <button
                onClick={exportToExcelPeriod}
                style={{
                  ...styles.alertButton,
                  background: 'linear-gradient(135deg, #3B82F6 0%, #1D4ED8 100%)',
                }}
                title="Exporter les encaissements par période"
              >
                <FileSpreadsheet size={20} />
                <span>Excel Période</span>
              </button>

              <div style={styles.viewToggle}>
                <button
                  onClick={() => setViewMode('table')}
                  style={{
                    ...styles.viewButton,
                    ...(viewMode === 'table' ? styles.viewButtonActive : {}),
                  }}
                >
                  <List size={20} />
                </button>
                <button
                  onClick={() => setViewMode('cards')}
                  style={{
                    ...styles.viewButton,
                    ...(viewMode === 'cards' ? styles.viewButtonActive : {}),
                  }}
                >
                  <Grid size={20} />
                </button>
              </div>

              <button onClick={toggleModal} style={styles.alertButton}>
                <AlertTriangle size={20} />
                <span>Alertes</span>
              </button>
            </div>
          </div>
        </div>

        {/* ✅ AJOUTÉ : Filtres avancés par période et critères */}
        <div style={{ marginBottom: '24px' }}>
          {!showAdvancedFilters ? (
            <button
              onClick={() => setShowAdvancedFilters(true)}
              style={{
                background: '#F3F4F6',
                color: '#374151',
                border: '1px solid #E5E7EB',
                borderRadius: '8px',
                padding: '10px 16px',
                fontSize: '14px',
                fontWeight: '500',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
              }}
            >
              <span>Filtres avancés par période</span>
              {getActiveFiltersCount() > 0 && (
                <span style={{
                  background: '#3B82F6',
                  color: 'white',
                  fontSize: '11px',
                  fontWeight: 'bold',
                  borderRadius: '50%',
                  width: '18px',
                  height: '18px',
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  {getActiveFiltersCount()}
                </span>
              )}
              <span>▼</span>
            </button>
          ) : (
            <div style={{
              background: 'white',
              borderRadius: '12px',
              border: '1px solid #E5E7EB',
              padding: '20px',
              boxShadow: '0 4px 6px rgba(0, 0, 0, 0.05)',
              display: 'flex',
              flexDirection: 'column',
              gap: '16px'
            }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h3 style={{ margin: 0, fontSize: '16px', fontWeight: '600', color: '#1F2937' }}>
                  Filtres avancés par période & critères
                </h3>
                <button
                  onClick={() => setShowAdvancedFilters(false)}
                  style={{
                    background: 'transparent',
                    border: 'none',
                    cursor: 'pointer',
                    color: '#9CA3AF',
                    fontSize: '14px',
                    fontWeight: '500'
                  }}
                >
                  Fermer ▲
                </button>
              </div>

              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                gap: '16px'
              }}>
                {/* Type de Période */}
                <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                  <label style={{ fontSize: '13px', fontWeight: '500', color: '#374151' }}>Type de Période</label>
                  <select
                    value={filters.typePeriode}
                    onChange={(e) => setFilters(prev => ({ ...prev, typePeriode: e.target.value }))}
                    style={{
                      padding: '10px',
                      borderRadius: '6px',
                      border: '1px solid #D1D5DB',
                      fontSize: '14px',
                      backgroundColor: 'white'
                    }}
                  >
                    <option value="tous">Tous les paiements</option>
                    <option value="jour">Par Jour</option>
                    <option value="semaine">Par Semaine</option>
                    <option value="mois">Par Mois</option>
                    <option value="personnalise">Période personnalisée (Du/Au)</option>
                  </select>
                </div>

                {/* Inputs conditionnels selon le type de période */}
                {filters.typePeriode === 'jour' && (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                    <label style={{ fontSize: '13px', fontWeight: '500', color: '#374151' }}>Sélectionner le Jour</label>
                    <input
                      type="date"
                      value={filters.dateCible}
                      onChange={(e) => setFilters(prev => ({ ...prev, dateCible: e.target.value }))}
                      style={{ padding: '8px 10px', borderRadius: '6px', border: '1px solid #D1D5DB', fontSize: '14px' }}
                    />
                  </div>
                )}

                {filters.typePeriode === 'semaine' && (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                    <label style={{ fontSize: '13px', fontWeight: '500', color: '#374151' }}>Choisir un jour de la semaine</label>
                    <input
                      type="date"
                      value={filters.dateCible}
                      onChange={(e) => setFilters(prev => ({ ...prev, dateCible: e.target.value }))}
                      style={{ padding: '8px 10px', borderRadius: '6px', border: '1px solid #D1D5DB', fontSize: '14px' }}
                    />
                    <span style={{ fontSize: '11px', color: '#6B7280' }}>Filtre la semaine entière (lun. au dim.)</span>
                  </div>
                )}

                {filters.typePeriode === 'mois' && (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                    <label style={{ fontSize: '13px', fontWeight: '500', color: '#374151' }}>Sélectionner le Mois</label>
                    <input
                      type="month"
                      value={filters.moisCible}
                      onChange={(e) => setFilters(prev => ({ ...prev, moisCible: e.target.value }))}
                      style={{ padding: '8px 10px', borderRadius: '6px', border: '1px solid #D1D5DB', fontSize: '14px', backgroundColor: 'white' }}
                    />
                  </div>
                )}

                {filters.typePeriode === 'personnalise' && (
                  <>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                      <label style={{ fontSize: '13px', fontWeight: '500', color: '#374151' }}>Date de Début</label>
                      <input
                        type="date"
                        value={filters.dateDebut}
                        onChange={(e) => setFilters(prev => ({ ...prev, dateDebut: e.target.value }))}
                        style={{ padding: '8px 10px', borderRadius: '6px', border: '1px solid #D1D5DB', fontSize: '14px' }}
                      />
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                      <label style={{ fontSize: '13px', fontWeight: '500', color: '#374151' }}>Date de Fin</label>
                      <input
                        type="date"
                        value={filters.dateFin}
                        onChange={(e) => setFilters(prev => ({ ...prev, dateFin: e.target.value }))}
                        style={{ padding: '8px 10px', borderRadius: '6px', border: '1px solid #D1D5DB', fontSize: '14px' }}
                      />
                    </div>
                  </>
                )}

                {/* Montant Min */}
                <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                  <label style={{ fontSize: '13px', fontWeight: '500', color: '#374151' }}>Montant Min (DH)</label>
                  <input
                    type="number"
                    placeholder="Ex: 1000"
                    value={filters.montantMin}
                    onChange={(e) => setFilters(prev => ({ ...prev, montantMin: e.target.value }))}
                    style={{ padding: '8px 10px', borderRadius: '6px', border: '1px solid #D1D5DB', fontSize: '14px' }}
                  />
                </div>

                {/* Montant Max */}
                <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                  <label style={{ fontSize: '13px', fontWeight: '500', color: '#374151' }}>Montant Max (DH)</label>
                  <input
                    type="number"
                    placeholder="Ex: 5000"
                    value={filters.montantMax}
                    onChange={(e) => setFilters(prev => ({ ...prev, montantMax: e.target.value }))}
                    style={{ padding: '8px 10px', borderRadius: '6px', border: '1px solid #D1D5DB', fontSize: '14px' }}
                  />
                </div>

                {/* Mode de paiement */}
                <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                  <label style={{ fontSize: '13px', fontWeight: '500', color: '#374151' }}>Mode de Paiement</label>
                  <select
                    value={filters.modePayment}
                    onChange={(e) => setFilters(prev => ({ ...prev, modePayment: e.target.value }))}
                    style={{
                      padding: '10px',
                      borderRadius: '6px',
                      border: '1px solid #D1D5DB',
                      fontSize: '14px',
                      backgroundColor: 'white'
                    }}
                  >
                    <option value="">Tous les modes</option>
                    <option value="Espèce">Espèce</option>
                    <option value="Chèque encaissé">Chèque encaissé</option>
                    <option value="Versement">Versement</option>
                    <option value="Virement">Virement</option>
                    <option value="Chèque non encaissé">Chèque non encaissé</option>
                  </select>
                </div>
              </div>

              <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px', marginTop: '8px' }}>
                <button
                  onClick={resetFilters}
                  style={{
                    padding: '8px 16px',
                    border: '1px solid #D1D5DB',
                    borderRadius: '6px',
                    backgroundColor: 'white',
                    color: '#374151',
                    fontSize: '14px',
                    fontWeight: '500',
                    cursor: 'pointer'
                  }}
                >
                  Réinitialiser les filtres
                </button>
              </div>
            </div>
          )}
        </div>

        <div style={styles.resultsCount}>
          <p>
            {filteredPaiements.length} paiement{filteredPaiements.length > 1 ? 's' : ''} trouvé{filteredPaiements.length > 1 ? 's' : ''}
            {searchTerm && ` pour "${searchTerm}"`}
            {filterNiveauFormation && ` · Niveau: ${filterNiveauFormation}`}
          </p>
        </div>

        {viewMode === 'table' ? (
          <div style={styles.tableContainer}>
            <table style={styles.table}>
              <thead style={styles.thead}>
                <tr>
                  <th style={styles.th}>Étudiant</th>
                  <th style={styles.th}>Filière</th>
                  <th style={styles.th}>Niveau</th>
                  <th style={styles.th}>Spécialité</th>
                  <th style={styles.th}>N° Série</th>
                  <th style={styles.th}>Début</th>
                  <th style={styles.th}>Durée</th>
                  <th style={styles.th}>Mode</th>
                  <th style={styles.th}>Montant</th>
                  <th style={styles.th}>Payé le</th>
                  <th style={styles.th}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredPaiements.map((p) => {
                  const filiere = p.etudiant?.filiere || '—';
                  const niveau = p.etudiant?.niveau || p.etudiant?.niveauFormation || '—';
                  const specialite =
                    p.etudiant?.specialiteIngenieur ||
                    p.etudiant?.specialiteLicencePro ||
                    p.etudiant?.specialiteMasterPro ||
                    p.etudiant?.specialite ||
                    '—';

                  return (
                    <tr key={p._id}>
                      <td style={styles.td}>
                        <div style={styles.userCell}>
                          <div style={styles.tableAvatar}>
                            <User size={16} color="white" />
                          </div>
                          <div>
                            <span style={styles.userName}>
                              {p.etudiant?.nomComplet ||
                                (p.etudiant ? `${p.etudiant.nomDeFamille || ''} ${p.etudiant.prenom || ''}`.trim() : '—')}
                              {p.etudiant && !p.etudiant.actif && (
                                <span style={{
                                  marginLeft: '8px',
                                  fontSize: '10px',
                                  backgroundColor: '#EF4444',
                                  color: 'white',
                                  padding: '2px 6px',
                                  borderRadius: '4px',
                                  fontWeight: '600'
                                }}>
                                  Archivé
                                </span>
                              )}
                            </span>
                            {p.etudiant?.codeEtudiant && (
                              <div style={{ fontSize: '11px', color: '#6B7280', marginTop: '2px', fontFamily: 'monospace' }}>
                                {p.etudiant.codeEtudiant}
                              </div>
                            )}
                          </div>
                        </div>
                      </td>
                      <td style={styles.td}>{filiere}</td>
                      <td style={styles.td}>{niveau}</td>
                      <td style={styles.td}>{specialite}</td>
                      <td style={styles.td}>
                        <span style={{ fontFamily: 'monospace', fontSize: '12px' }}>
                          {p.isDummy ? '—' : (p.numeroSerie || '—')}
                        </span>
                        {!p.isDummy && p.numeroSerieManuel && (
                          <div style={{ fontSize: '11px', color: '#4f46e5', fontWeight: '600', marginTop: '2px' }}>
                            ({p.numeroSerieManuel})
                          </div>
                        )}
                      </td>
                      <td style={styles.td}>{p.isDummy ? '—' : formatDate(p.moisDebut)}</td>
                      <td style={styles.td}>
                        {p.isDummy ? (
                          <span style={{ ...styles.durationBadge, backgroundColor: '#FEE2E2', color: '#991B1B' }}>
                            Aucune
                          </span>
                        ) : (
                          <span style={styles.durationBadge}>{p.nombreMois} mois</span>
                        )}
                      </td>
                      <td style={styles.td}>
                        <span
                          style={{
                            backgroundColor: p.isDummy ? '#FEE2E2' : '#E0F2FE',
                            color: p.isDummy ? '#991B1B' : '#0369A1',
                            padding: '4px 12px',
                            borderRadius: '20px',
                            fontSize: '13px',
                            fontWeight: '500',
                          }}
                        >
                          {p.modePayment || '—'}
                        </span>
                      </td>
                      <td style={styles.td}>
                        <span style={{ ...styles.amount, color: p.isDummy ? '#EF4444' : '#059669' }}>
                          {p.isDummy ? '0 Dh (Non payé)' : `${p.montant} Dh`}
                        </span>
                      </td>
                      <td style={styles.td}>{p.isDummy ? '—' : formatDate(p.datePaiement || p.createdAt)}</td>
                      <td style={styles.td}>
                        <div style={{ display: 'flex', gap: '8px' }}>
                          {p.isDummy ? (
                            <>
                              {!isHiba && (
                                <button
                                  onClick={() => payerEtudiant(p.etudiant?._id, p.etudiant?.cours)}
                                  style={{
                                    padding: '6px 12px',
                                    backgroundColor: '#059669',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '6px',
                                    cursor: 'pointer',
                                    fontSize: '12px',
                                    fontWeight: '600',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '4px'
                                  }}
                                  title="Enregistrer un paiement"
                                >
                                  💰 Payer
                                </button>
                              )}
                              {canEditObs && (
                                <button
                                  onClick={() => openObsModal(p)}
                                  style={{
                                    ...styles.actionButton,
                                    backgroundColor: '#8B5CF6',
                                    color: 'white',
                                  }}
                                  title="Modifier l'observation financière"
                                >
                                  <FileText size={16} />
                                </button>
                              )}
                            </>
                          ) : (
                            <>
                              <button
                                onClick={() => openDetailModal(p)}
                                style={{
                                  ...styles.actionButton,
                                  backgroundColor: '#10B981',
                                  color: 'white',
                                }}
                                title="Voir détails"
                              >
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                  <path
                                    d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
                                    fill="currentColor"
                                  />
                                  <path
                                    d="M2.04834 12.3178C1.98398 12.1126 1.98398 11.8874 2.04834 11.6822C3.11287 8.64174 7.23449 4 12 4C16.7655 4 20.8871 8.64174 21.9517 11.6822C22.016 11.8874 22.016 12.1126 21.9517 12.3178C20.8871 15.3583 16.7655 20 12 20C7.23449 20 3.11287 15.3583 2.04834 12.3178Z"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                  />
                                </svg>
                              </button>
                              <button
                                onClick={() => generatePDF(p)}
                                style={{
                                  ...styles.actionButton,
                                  backgroundColor: '#3B82F6',
                                  color: 'white',
                                }}
                                title="Télécharger PDF"
                              >
                                <Download size={16} />
                              </button>
                              {!isHiba && (
                                <button
                                  onClick={() => openEditModal(p)}
                                  style={{
                                    ...styles.actionButton,
                                    backgroundColor: '#F59E0B',
                                    color: 'white',
                                  }}
                                  title="Modifier"
                                >
                                  <Edit size={16} />
                                </button>
                              )}
                              {canEditObs && (
                                <button
                                  onClick={() => openObsModal(p)}
                                  style={{
                                    ...styles.actionButton,
                                    backgroundColor: '#8B5CF6',
                                    color: 'white',
                                  }}
                                  title="Modifier l'observation financière"
                                >
                                  <FileText size={16} />
                                </button>
                              )}
                              {!isHiba && (
                                <button
                                  onClick={() => handleDelete(p)}
                                  style={{
                                    ...styles.actionButton,
                                    backgroundColor: '#EF4444',
                                    color: 'white',
                                  }}
                                  title="Supprimer"
                                >
                                  <Trash2 size={16} />
                                </button>
                              )}
                            </>
                          )}
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        ) : (
          <div style={styles.cardsGrid}>
            {filteredPaiements.map(p => (
              <CardView key={p._id} paiement={p} />
            ))}
          </div>
        )}

        {filteredPaiements.length === 0 && (
          <div style={{ textAlign: 'center', padding: '48px 0' }}>
            <CreditCard size={64} color="#D1D5DB" />
            <h3 style={{ fontSize: '18px', fontWeight: '500', color: '#111827', marginTop: '16px' }}>
              Aucun paiement trouvé
            </h3>
            <p style={{ color: '#6B7280' }}>
              {searchTerm || filterNiveauFormation ? 'Essayez avec d\'autres filtres' : 'Aucun paiement enregistré'}
            </p>
          </div>
        )}

        {/* Modal Alertes */}
        {showModal && (
          <div style={styles.modal}>
            <div style={styles.modalContent}>
              <div style={styles.modalHeader}>
                <h3 style={styles.modalTitle}>
                  <AlertTriangle size={24} />
                  Paiements Expirés
                </h3>
                <button onClick={toggleModal} style={styles.closeButton}>
                  <X size={20} />
                </button>
              </div>
              <div style={styles.modalBody}>
                {expirés.length === 0 ? (
                  <div style={{ textAlign: 'center', padding: '32px 0' }}>
                    <div style={{
                      width: '64px',
                      height: '64px',
                      background: '#DCFCE7',
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      margin: '0 auto 16px',
                    }}>
                      <span style={{ fontSize: '32px' }}>✅</span>
                    </div>
                    <p>Aucun paiement expiré</p>
                  </div>
                ) : (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                    {expirés.filter(p => p.etudiant?.actif).map(p => (
                      <div key={p._id} style={{
                        background: '#FFF7ED',
                        borderRadius: '12px',
                        padding: '16px',
                        borderLeft: '4px solid #F59E0B',
                      }}>
                        <div style={{ marginBottom: '12px' }}>
                          <h4 style={{ margin: '0 0 4px 0', fontWeight: '600' }}>
                            {p.etudiant?.nomComplet}
                          </h4>
                          <p style={{ margin: 0, fontSize: '14px', color: '#6B7280' }}>
                            {Array.isArray(p.cours) ? p.cours.join(', ') : p.cours}
                          </p>
                        </div>
                        <button
                          onClick={() => payerEtudiant(p.etudiant?._id, p.cours)}
                          style={{
                            width: '100%',
                            background: '#059669',
                            color: 'white',
                            padding: '12px',
                            borderRadius: '8px',
                            border: 'none',
                            cursor: 'pointer',
                            fontWeight: '500',
                          }}
                        >
                          💰 Payer maintenant
                        </button>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        {/* Modal Détails */}
        {showDetailModal && selectedPaiement && (
          <div style={styles.modal}>
            <div style={styles.modalContent}>
              <div style={{
                ...styles.modalHeader,
                background: 'linear-gradient(135deg, #3B82F6 0%, #8B5CF6 100%)',
              }}>
                <h3 style={styles.modalTitle}>
                  <CreditCard size={24} />
                  Détails du Paiement
                </h3>
                <button onClick={closeDetailModal} style={styles.closeButton}>
                  <X size={20} />
                </button>
              </div>
              <div style={styles.modalBody}>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '16px' }}>
                  <div style={{ background: '#F8FAFC', padding: '16px', borderRadius: '8px' }}>
                    <div style={{ fontSize: '12px', color: '#64748B', marginBottom: '4px' }}>Étudiant</div>
                    <div style={{ fontWeight: '600' }}>{selectedPaiement.etudiant?.nomComplet}</div>
                  </div>
                  <div style={{ background: '#F8FAFC', padding: '16px', borderRadius: '8px' }}>
                    <div style={{ fontSize: '12px', color: '#64748B', marginBottom: '4px' }}>Montant</div>
                    <div style={{ fontWeight: '600', color: '#059669' }}>{selectedPaiement.montant} Dh</div>
                  </div>
                  <div style={{ background: '#F8FAFC', padding: '16px', borderRadius: '8px' }}>
                    <div style={{ fontSize: '12px', color: '#64748B', marginBottom: '4px' }}>N° Série</div>
                    <div style={{ fontWeight: '600', fontFamily: 'monospace', fontSize: '14px' }}>
                      {selectedPaiement.numeroSerie || '—'}
                    </div>
                    {selectedPaiement.numeroSerieManuel && (
                      <div style={{ fontSize: '12px', color: '#4F46E5', fontWeight: '600', marginTop: '4px' }}>
                        N° Série 2: {selectedPaiement.numeroSerieManuel}
                      </div>
                    )}
                  </div>
                  <div style={{ background: '#F8FAFC', padding: '16px', borderRadius: '8px' }}>
                    <div style={{ fontSize: '12px', color: '#64748B', marginBottom: '4px' }}>Durée</div>
                    <div style={{ fontWeight: '600' }}>{selectedPaiement.nombreMois} mois</div>
                  </div>
                  <div style={{ background: '#F8FAFC', padding: '16px', borderRadius: '8px' }}>
                    <div style={{ fontSize: '12px', color: '#64748B', marginBottom: '4px' }}>Mode de Paiement</div>
                    <div style={{ fontWeight: '600' }}>{selectedPaiement.modePayment || '—'}</div>
                  </div>
                  <div style={{ background: '#F8FAFC', padding: '16px', borderRadius: '8px' }}>
                    <div style={{ fontSize: '12px', color: '#64748B', marginBottom: '4px' }}>Date de Paiement</div>
                    <div style={{ fontWeight: '600' }}>{formatDate(selectedPaiement.datePaiement || selectedPaiement.createdAt)}</div>
                  </div>
                  {selectedPaiement.banque && (
                    <div style={{ background: '#F8FAFC', padding: '16px', borderRadius: '8px' }}>
                      <div style={{ fontSize: '12px', color: '#64748B', marginBottom: '4px' }}>Banque</div>
                      <div style={{ fontWeight: '600' }}>{selectedPaiement.banque}</div>
                    </div>
                  )}
                  {selectedPaiement.numeroCheque && (
                    <div style={{ background: '#F8FAFC', padding: '16px', borderRadius: '8px' }}>
                      <div style={{ fontSize: '12px', color: '#64748B', marginBottom: '4px' }}>N° Chèque</div>
                      <div style={{ fontWeight: '600', fontFamily: 'monospace' }}>{selectedPaiement.numeroCheque}</div>
                    </div>
                  )}
                </div>
                {selectedPaiement.note && (
                  <div style={{ background: '#FEF3C7', padding: '16px', borderRadius: '8px', marginTop: '16px' }}>
                    <div style={{ fontSize: '12px', color: '#92400E', marginBottom: '8px', fontWeight: '500' }}>
                      📝 Note
                    </div>
                    <div style={{ fontSize: '14px', color: '#451A03' }}>{selectedPaiement.note}</div>
                  </div>
                )}
                {selectedPaiement.etudiant?.observationFinance && (
                  <div style={{ background: '#F5F3FF', padding: '16px', borderRadius: '8px', marginTop: '16px', borderLeft: '4px solid #8B5CF6' }}>
                    <div style={{ fontSize: '12px', color: '#6D28D9', marginBottom: '8px', fontWeight: '500', display: 'flex', alignItems: 'center', gap: '6px' }}>
                      <FileText size={16} /> Observation financière générale (Étudiant)
                    </div>
                    <div style={{ fontSize: '14px', color: '#1F2937' }}>{selectedPaiement.etudiant.observationFinance}</div>
                  </div>
                )}
                {selectedPaiement.observationFinance && (
                  <div style={{ background: '#EFF6FF', padding: '16px', borderRadius: '8px', marginTop: '16px', borderLeft: '4px solid #3B82F6' }}>
                    <div style={{ fontSize: '12px', color: '#1D4ED8', marginBottom: '8px', fontWeight: '500', display: 'flex', alignItems: 'center', gap: '6px' }}>
                      <FileText size={16} /> Observation financière spécifique (Ce paiement)
                    </div>
                    <div style={{ fontSize: '14px', color: '#1F2937' }}>{selectedPaiement.observationFinance}</div>
                  </div>
                )}
                <div style={styles.buttonGroup}>
                  <button
                    onClick={() => generatePDF(selectedPaiement)}
                    style={styles.saveButton}
                  >
                    <Download size={16} style={{ marginRight: '8px' }} />
                    Télécharger PDF
                  </button>
                  <button onClick={closeDetailModal} style={styles.cancelButton}>
                    Fermer
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Modal Édition */}
        {showEditModal && selectedPaiement && (
          <div style={styles.modal}>
            <div style={styles.modalContent}>
              <div style={styles.editModalHeader}>
                <h3 style={styles.modalTitle}>
                  <Edit size={24} />
                  Modifier le Paiement
                </h3>
                <button onClick={() => setShowEditModal(false)} style={styles.closeButton}>
                  <X size={20} />
                </button>
              </div>
              <div style={styles.modalBody}>
                <div style={styles.formGroup}>
                  <label style={styles.label}>Numéro de Série *</label>
                  <input
                    type="text"
                    value={editForm.numeroSerie}
                    onChange={(e) => setEditForm({ ...editForm, numeroSerie: e.target.value })}
                    style={styles.input}
                    placeholder="Ex: PAY-2025-001"
                  />
                </div>

                <div style={styles.formGroup}>
                  <label style={styles.label}>N° Série 2 (Optionnel)</label>
                  <input
                    type="text"
                    value={editForm.numeroSerieManuel || ''}
                    onChange={(e) => setEditForm({ ...editForm, numeroSerieManuel: e.target.value })}
                    style={styles.input}
                    placeholder="Ex: REC-2026-001"
                  />
                </div>

                <div style={styles.formGroup}>
                  <label style={styles.label}>Montant (DH) *</label>
                  <input
                    type="number"
                    value={editForm.montant}
                    onChange={(e) => setEditForm({ ...editForm, montant: e.target.value })}
                    style={styles.input}
                    min="0"
                    step="0.01"
                  />
                </div>

                <div style={styles.formGroup}>
                  <label style={styles.label}>Date de début</label>
                  <input
                    type="date"
                    value={editForm.moisDebut}
                    onChange={(e) => setEditForm({ ...editForm, moisDebut: e.target.value })}
                    style={styles.input}
                  />
                </div>

                <div style={styles.formGroup}>
                  <label style={styles.label}>Date de Paiement *</label>
                  <input
                    type="date"
                    value={editForm.datePaiement}
                    onChange={(e) => setEditForm({ ...editForm, datePaiement: e.target.value })}
                    style={styles.input}
                  />
                </div>

                <div style={styles.formGroup}>
                  <label style={styles.label}>Nombre de mois</label>
                  <input
                    type="number"
                    value={editForm.nombreMois}
                    onChange={(e) => setEditForm({ ...editForm, nombreMois: e.target.value })}
                    style={styles.input}
                    min="1"
                  />
                </div>

                <div style={styles.formGroup}>
                  <label style={styles.label}>Mode de Paiement</label>
                  <select
                    value={editForm.modePayment || ''}
                    onChange={(e) => setEditForm({ ...editForm, modePayment: e.target.value || null })}
                    style={styles.input}
                  >
                    <option value="">-- Sélectionner --</option>
                    <option value="Espèce">Espèce</option>
                    <option value="Chèque encaissé">Chèque encaissé</option>
                    <option value="Versement">Versement</option>
                    <option value="Virement">Virement</option>
                    <option value="Chèque non encaissé">Chèque non encaissé</option>
                  </select>
                </div>

                {(editForm.modePayment?.toLowerCase().includes('ch') || editForm.banque || editForm.numeroCheque) && (
                  <>
                    <div style={styles.formGroup}>
                      <label style={styles.label}>Banque (Chèque)</label>
                      <input
                        type="text"
                        value={editForm.banque || ''}
                        onChange={(e) => setEditForm({ ...editForm, banque: e.target.value })}
                        style={styles.input}
                        placeholder="Ex: Attijariwafa Bank, BMCE, CIH..."
                      />
                    </div>
                    <div style={styles.formGroup}>
                      <label style={styles.label}>Numéro de Chèque</label>
                      <input
                        type="text"
                        value={editForm.numeroCheque || ''}
                        onChange={(e) => setEditForm({ ...editForm, numeroCheque: e.target.value })}
                        style={styles.input}
                        placeholder="Ex: 0048291"
                      />
                    </div>
                  </>
                )}

                <div style={styles.formGroup}>
                  <label style={styles.label}>Note (optionnel)</label>
                  <textarea
                    value={editForm.note}
                    onChange={(e) => setEditForm({ ...editForm, note: e.target.value })}
                    style={styles.textarea}
                    placeholder="Ajouter une note..."
                  />
                </div>

                <div style={styles.buttonGroup}>
                  <button onClick={handleEditSubmit} style={styles.saveButton}>
                    💾 Enregistrer
                  </button>
                  <button onClick={() => setShowEditModal(false)} style={styles.cancelButton}>
                    Annuler
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Modal Modification Observation Financière */}
        {showObsModal && selectedEtudiantForObs && (
          <div style={styles.modal}>
            <div style={{ ...styles.modalContent, maxWidth: '500px' }}>
              <div style={{
                ...styles.modalHeader,
                background: 'linear-gradient(135deg, #8B5CF6 0%, #6D28D9 100%)',
              }}>
                <h3 style={styles.modalTitle}>
                  <FileText size={24} style={{ marginRight: '8px' }} />
                  Observation Financière
                </h3>
                <button onClick={() => { setShowObsModal(false); setSelectedEtudiantForObs(null); }} style={styles.closeButton}>
                  <X size={20} />
                </button>
              </div>
              <form onSubmit={handleObsSubmit}>
                <div style={styles.modalBody}>
                  <div style={{ marginBottom: '16px', background: '#F5F3FF', padding: '12px 16px', borderRadius: '8px', borderLeft: '4px solid #8B5CF6' }}>
                    <div style={{ fontSize: '12px', color: '#6D28D9', fontWeight: '600', marginBottom: '2px' }}>Étudiant</div>
                    <div style={{ fontWeight: '700', fontSize: '15px', color: '#1F2937' }}>{selectedEtudiantForObs.nomComplet}</div>
                  </div>

                  <div style={styles.formGroup}>
                    <label style={{ ...styles.label, fontWeight: '600' }}>Observations financières générales (Étudiant)</label>
                    <textarea
                      value={obsValue}
                      onChange={(e) => setObsValue(e.target.value)}
                      style={{
                        ...styles.textarea,
                        minHeight: '80px',
                        border: '1px solid #d1d5db',
                        borderRadius: '8px',
                        padding: '10px',
                        fontSize: '14px',
                        width: '100%',
                        boxSizing: 'border-box',
                        marginBottom: '12px'
                      }}
                      placeholder="Observations générales (ex: bourse, réduction globale...)"
                    />
                  </div>

                  <div style={styles.formGroup}>
                    <label style={{ ...styles.label, fontWeight: '600' }}>Observations financières spécifiques (Ce paiement)</label>
                    <textarea
                      value={paymentObsValue}
                      onChange={(e) => setPaymentObsValue(e.target.value)}
                      style={{
                        ...styles.textarea,
                        minHeight: '80px',
                        border: '1px solid #d1d5db',
                        borderRadius: '8px',
                        padding: '10px',
                        fontSize: '14px',
                        width: '100%',
                        boxSizing: 'border-box'
                      }}
                      placeholder="Observations pour ce versement (ex: chèque de caution...)"
                    />
                  </div>

                  <div style={{ ...styles.buttonGroup, marginTop: '20px' }}>
                    <button
                      type="submit"
                      style={{
                        ...styles.saveButton,
                        background: 'linear-gradient(135deg, #8B5CF6 0%, #6D28D9 100%)',
                        border: 'none',
                        color: 'white',
                        padding: '10px 20px',
                        borderRadius: '8px',
                        fontWeight: '600',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: 'auto'
                      }}
                      disabled={obsSubmitting}
                    >
                      {obsSubmitting ? 'Enregistrement...' : '💾 Enregistrer'}
                    </button>
                    <button
                      type="button"
                      onClick={() => { setShowObsModal(false); setSelectedEtudiantForObs(null); }}
                      style={styles.cancelButton}
                      disabled={obsSubmitting}
                    >
                      Annuler
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ListePaiements;